/* eslint-disable */

// @ts-nocheck



const peggyParser: {parse: any, SyntaxError: any, DefaultTracer?: any} = // @generated by Peggy 5.1.0.
//
// https://peggyjs.org/
// @ts-ignore
(function() {
// @ts-ignore
  "use strict";
// @ts-ignore
class peg$SyntaxError extends SyntaxError {
// @ts-ignore
  constructor(message, expected, found, location) {
// @ts-ignore
    super(message);
// @ts-ignore
    this.expected = expected;
// @ts-ignore
    this.found = found;
// @ts-ignore
    this.location = location;
// @ts-ignore
    this.name = "SyntaxError";
  }

// @ts-ignore
  format(sources) {
// @ts-ignore
    let str = "Error: " + this.message;
// @ts-ignore
    if (this.location) {
// @ts-ignore
      let src = null;
// @ts-ignore
      const st = sources.find(s => s.source === this.location.source);
// @ts-ignore
      if (st) {
// @ts-ignore
        src = st.text.split(/\r\n|\n|\r/g);
      }
// @ts-ignore
      const s = this.location.start;
// @ts-ignore
      const offset_s = (this.location.source && (typeof this.location.source.offset === "function"))
// @ts-ignore
        ? this.location.source.offset(s)
// @ts-ignore
        : s;
// @ts-ignore
      const loc = this.location.source + ":" + offset_s.line + ":" + offset_s.column;
// @ts-ignore
      if (src) {
// @ts-ignore
        const e = this.location.end;
// @ts-ignore
        const filler = "".padEnd(offset_s.line.toString().length, " ");
// @ts-ignore
        const line = src[s.line - 1];
// @ts-ignore
        const last = s.line === e.line ? e.column : line.length + 1;
// @ts-ignore
        const hatLen = (last - s.column) || 1;
// @ts-ignore
        str += "\n --> " + loc + "\n"
// @ts-ignore
            + filler + " |\n"
// @ts-ignore
            + offset_s.line + " | " + line + "\n"
// @ts-ignore
            + filler + " | " + "".padEnd(s.column - 1, " ")
// @ts-ignore
            + "".padEnd(hatLen, "^");
// @ts-ignore
      } else {
// @ts-ignore
        str += "\n at " + loc;
      }
    }
// @ts-ignore
    return str;
  }

// @ts-ignore
  static buildMessage(expected, found) {
// @ts-ignore
    function hex(ch) {
// @ts-ignore
      return ch.codePointAt(0).toString(16).toUpperCase();
    }

// @ts-ignore
    const nonPrintable = Object.prototype.hasOwnProperty.call(RegExp.prototype, "unicode")
// @ts-ignore
      ? new RegExp("[\\p{C}\\p{Mn}\\p{Mc}]", "gu")
// @ts-ignore
      : null;
// @ts-ignore
    function unicodeEscape(s) {
// @ts-ignore
      if (nonPrintable) {
// @ts-ignore
        return s.replace(nonPrintable,  ch => "\\u{" + hex(ch) + "}");
      }
// @ts-ignore
      return s;
    }

// @ts-ignore
    function literalEscape(s) {
// @ts-ignore
      return unicodeEscape(s
// @ts-ignore
        .replace(/\\/g, "\\\\")
// @ts-ignore
        .replace(/"/g,  "\\\"")
// @ts-ignore
        .replace(/\0/g, "\\0")
// @ts-ignore
        .replace(/\t/g, "\\t")
// @ts-ignore
        .replace(/\n/g, "\\n")
// @ts-ignore
        .replace(/\r/g, "\\r")
// @ts-ignore
        .replace(/[\x00-\x0F]/g,          ch => "\\x0" + hex(ch))
// @ts-ignore
        .replace(/[\x10-\x1F\x7F-\x9F]/g, ch => "\\x"  + hex(ch)));
    }

// @ts-ignore
    function classEscape(s) {
// @ts-ignore
      return unicodeEscape(s
// @ts-ignore
        .replace(/\\/g, "\\\\")
// @ts-ignore
        .replace(/\]/g, "\\]")
// @ts-ignore
        .replace(/\^/g, "\\^")
// @ts-ignore
        .replace(/-/g,  "\\-")
// @ts-ignore
        .replace(/\0/g, "\\0")
// @ts-ignore
        .replace(/\t/g, "\\t")
// @ts-ignore
        .replace(/\n/g, "\\n")
// @ts-ignore
        .replace(/\r/g, "\\r")
// @ts-ignore
        .replace(/[\x00-\x0F]/g,          ch => "\\x0" + hex(ch))
// @ts-ignore
        .replace(/[\x10-\x1F\x7F-\x9F]/g, ch => "\\x"  + hex(ch)));
    }

// @ts-ignore
    const DESCRIBE_EXPECTATION_FNS = {
// @ts-ignore
      literal(expectation) {
// @ts-ignore
        return "\"" + literalEscape(expectation.text) + "\"";
      },

// @ts-ignore
      class(expectation) {
// @ts-ignore
        const escapedParts = expectation.parts.map(
// @ts-ignore
          part => (Array.isArray(part)
// @ts-ignore
            ? classEscape(part[0]) + "-" + classEscape(part[1])
// @ts-ignore
            : classEscape(part))
        );

// @ts-ignore
        return "[" + (expectation.inverted ? "^" : "") + escapedParts.join("") + "]" + (expectation.unicode ? "u" : "");
      },

// @ts-ignore
      any() {
// @ts-ignore
        return "any character";
      },

// @ts-ignore
      end() {
// @ts-ignore
        return "end of input";
      },

// @ts-ignore
      other(expectation) {
// @ts-ignore
        return expectation.description;
      },
    };

// @ts-ignore
    function describeExpectation(expectation) {
// @ts-ignore
      return DESCRIBE_EXPECTATION_FNS[expectation.type](expectation);
    }

// @ts-ignore
    function describeExpected(expected) {
// @ts-ignore
      const descriptions = expected.map(describeExpectation);
// @ts-ignore
      descriptions.sort();

// @ts-ignore
      if (descriptions.length > 0) {
// @ts-ignore
        let j = 1;
// @ts-ignore
        for (let i = 1; i < descriptions.length; i++) {
// @ts-ignore
          if (descriptions[i - 1] !== descriptions[i]) {
// @ts-ignore
            descriptions[j] = descriptions[i];
// @ts-ignore
            j++;
          }
        }
// @ts-ignore
        descriptions.length = j;
      }

// @ts-ignore
      switch (descriptions.length) {
// @ts-ignore
        case 1:
// @ts-ignore
          return descriptions[0];

// @ts-ignore
        case 2:
// @ts-ignore
          return descriptions[0] + " or " + descriptions[1];

// @ts-ignore
        default:
// @ts-ignore
          return descriptions.slice(0, -1).join(", ")
// @ts-ignore
            + ", or "
// @ts-ignore
            + descriptions[descriptions.length - 1];
      }
    }

// @ts-ignore
    function describeFound(found) {
// @ts-ignore
      return found ? "\"" + literalEscape(found) + "\"" : "end of input";
    }

// @ts-ignore
    return "Expected " + describeExpected(expected) + " but " + describeFound(found) + " found.";
  }
}

// @ts-ignore
function peg$parse(input, options) {
// @ts-ignore
  options = options !== undefined ? options : {};

// @ts-ignore
  const peg$FAILED = {};
// @ts-ignore
  const peg$source = options.grammarSource;

// @ts-ignore
  const peg$startRuleFunctions = {
    Filter: peg$parseFilter,
  };
// @ts-ignore
  let peg$startRuleFunction = peg$parseFilter;

// @ts-ignore
  const peg$c0 = "and";
  const peg$c1 = "or";
  const peg$c2 = "not";
  const peg$c3 = "contains";
  const peg$c4 = "null";
  const peg$c5 = "is";
  const peg$c6 = "empty";
  const peg$c7 = "in";
  const peg$c8 = "\"";
  const peg$c9 = "'";
  const peg$c10 = ":";
  const peg$c11 = ",";
  const peg$c12 = ".";
  const peg$c13 = "`";
  const peg$c14 = "(";
  const peg$c15 = ")";
  const peg$c16 = "==";
  const peg$c17 = "=";
  const peg$c18 = "<>";
  const peg$c19 = "!=";
  const peg$c20 = "<=";
  const peg$c21 = "<";
  const peg$c22 = ">=";
  const peg$c23 = ">";
  const peg$c24 = "-";
  const peg$c25 = "true";
  const peg$c26 = "false";

  const peg$r0 = /^[_a-zA-Z0-9]/;
  const peg$r1 = /^[\-*\/.a-zA-Z0-9]/;
  const peg$r2 = /^[\-*\/._a-zA-Z0-9]/;
  const peg$r3 = /^[^"]/;
  const peg$r4 = /^[^']/;
  const peg$r5 = /^[\-*\\a-zA-Z0-9_]/;
  const peg$r6 = /^[^`]/;
  const peg$r7 = /^[\-_a-zA-Z0-9!<>=]/;
  const peg$r8 = /^[0-9]/;
  const peg$r9 = /^[ \n\t\r]/;

  const peg$e0 = peg$literalExpectation("and", true);
  const peg$e1 = peg$literalExpectation("or", true);
  const peg$e2 = peg$literalExpectation("not", true);
  const peg$e3 = peg$literalExpectation("contains", true);
  const peg$e4 = peg$literalExpectation("null", true);
  const peg$e5 = peg$literalExpectation("is", true);
  const peg$e6 = peg$literalExpectation("empty", true);
  const peg$e7 = peg$literalExpectation("in", true);
  const peg$e8 = peg$classExpectation(["_", ["a", "z"], ["A", "Z"], ["0", "9"]], false, false, false);
  const peg$e9 = peg$classExpectation(["-", "*", "/", ".", ["a", "z"], ["A", "Z"], ["0", "9"]], false, false, false);
  const peg$e10 = peg$classExpectation(["-", "*", "/", ".", "_", ["a", "z"], ["A", "Z"], ["0", "9"]], false, false, false);
  const peg$e11 = peg$literalExpectation("\"", false);
  const peg$e12 = peg$classExpectation(["\""], true, false, false);
  const peg$e13 = peg$literalExpectation("'", false);
  const peg$e14 = peg$classExpectation(["'"], true, false, false);
  const peg$e15 = peg$literalExpectation(":", false);
  const peg$e16 = peg$otherExpectation("value");
  const peg$e17 = peg$otherExpectation("values");
  const peg$e18 = peg$literalExpectation(",", false);
  const peg$e19 = peg$literalExpectation(".", false);
  const peg$e20 = peg$classExpectation(["-", "*", "\\", ["a", "z"], ["A", "Z"], ["0", "9"], "_"], false, false, false);
  const peg$e21 = peg$literalExpectation("`", false);
  const peg$e22 = peg$classExpectation(["`"], true, false, false);
  const peg$e23 = peg$literalExpectation("(", false);
  const peg$e24 = peg$literalExpectation(")", false);
  const peg$e25 = peg$literalExpectation("==", false);
  const peg$e26 = peg$literalExpectation("=", false);
  const peg$e27 = peg$literalExpectation("<>", false);
  const peg$e28 = peg$literalExpectation("!=", false);
  const peg$e29 = peg$literalExpectation("<=", false);
  const peg$e30 = peg$literalExpectation("<", false);
  const peg$e31 = peg$literalExpectation(">=", false);
  const peg$e32 = peg$literalExpectation(">", false);
  const peg$e33 = peg$classExpectation(["-", "_", ["a", "z"], ["A", "Z"], ["0", "9"], "!", "<", ">", "="], false, false, false);
  const peg$e34 = peg$literalExpectation("-", false);
  const peg$e35 = peg$classExpectation([["0", "9"]], false, false, false);
  const peg$e36 = peg$literalExpectation("true", true);
  const peg$e37 = peg$literalExpectation("false", true);
  const peg$e38 = peg$classExpectation([" ", "\n", "\t", "\r"], false, false, false);
  const peg$e39 = peg$otherExpectation("whitespace");
  const peg$e40 = peg$anyExpectation();
// @ts-ignore

  function peg$f0(expr) {
// @ts-ignore
    return expr
  }// @ts-ignore

  function peg$f1(not) {
// @ts-ignore
    return {
// @ts-ignore
      value: text(),
// @ts-ignore
      location: location()
    }
  }// @ts-ignore

  function peg$f2(inKeyword) {
// @ts-ignore
    return {
// @ts-ignore
      value: text(),
// @ts-ignore
      location: location()
    }
  }// @ts-ignore

  function peg$f3(is) {
// @ts-ignore
    return {
// @ts-ignore
      value: text(),
// @ts-ignore
      location: location()
    }
  }// @ts-ignore

  function peg$f4(nullKeyword) {
// @ts-ignore
    return {
// @ts-ignore
      value: text(),
// @ts-ignore
      location: location()
    }
  }// @ts-ignore

  function peg$f5(contains) {
// @ts-ignore
    return {
// @ts-ignore
      value: text(),
// @ts-ignore
      location: location()
    }
  }// @ts-ignore

  function peg$f6(empty) {
// @ts-ignore
    return {
// @ts-ignore
      value: text(),
// @ts-ignore
      location: location()
    }
  }// @ts-ignore

  function peg$f7(and) {
// @ts-ignore
    return {
// @ts-ignore
      value: text(),
// @ts-ignore
      location: location()
    }
  }// @ts-ignore

  function peg$f8(or) {
// @ts-ignore
    return {
// @ts-ignore
      value: text(),
// @ts-ignore
      location: location()
    }
  }// @ts-ignore

  function peg$f9(value) {
// @ts-ignore
    return {
// @ts-ignore
      kind: 'raw-string',
// @ts-ignore
      value,
// @ts-ignore
      location: location(),
// @ts-ignore
      text: text(),
    }
  }// @ts-ignore

  function peg$f10(value) {
// @ts-ignore
    return {
// @ts-ignore
      kind: 'quoted-string',
// @ts-ignore
      value,
// @ts-ignore
      location: location(),
// @ts-ignore
      text: text(),
// @ts-ignore
      complete: true
    }
  }// @ts-ignore

  function peg$f11(value) {
// @ts-ignore
    return {
// @ts-ignore
      kind: 'quoted-string',
// @ts-ignore
      value,
// @ts-ignore
      location: location(),
// @ts-ignore
      text: text(),
// @ts-ignore
      complete: false
    }
  }// @ts-ignore

  function peg$f12(value) {
// @ts-ignore
    return {
// @ts-ignore
      kind: 'quoted-string',
// @ts-ignore
      value,
// @ts-ignore
      location: location(),
// @ts-ignore
      text: text(),
// @ts-ignore
      complete: true
    }
  }// @ts-ignore

  function peg$f13(value) {
// @ts-ignore
    return {
// @ts-ignore
      kind: 'quoted-string',
// @ts-ignore
      value,
// @ts-ignore
      location: location(),
// @ts-ignore
      text: text(),
// @ts-ignore
      complete: false
    }
  }// @ts-ignore

  function peg$f14(key, value) {
// @ts-ignore
    const isKeyIncompleteQuote = key && !key.complete;
// @ts-ignore
    const isValueIncompleteQuote = value && !value.complete;
    
// @ts-ignore
    return {
// @ts-ignore
      kind: 'quoted-key-value',
// @ts-ignore
      key,
// @ts-ignore
      keyLocation: key.location,
// @ts-ignore
      value,
// @ts-ignore
      valueLocation: value.location,
// @ts-ignore
      position: location(),
// @ts-ignore
      text: text(),
// @ts-ignore
      complete: !isKeyIncompleteQuote && !isValueIncompleteQuote
    }
  }// @ts-ignore

  function peg$f15(value, values) {
// @ts-ignore
    const valuesList = [value, ...values];
// @ts-ignore
    return valuesList;
  }// @ts-ignore

  function peg$f16(value, space) {
    // Single value with trailing comma (always complete)
// @ts-ignore
    return [value];
  }// @ts-ignore

  function peg$f17(value, space) {
    // Single value with optional space
// @ts-ignore
    const hasTrailingSpace = space && space.length > 0;
// @ts-ignore
    value.hasTrailingSpace = hasTrailingSpace;
// @ts-ignore
    return [value];
  }// @ts-ignore

  function peg$f18(seg, rest) {
// @ts-ignore
    const segments = [seg].concat(rest.segments);
// @ts-ignore
    const value = segments.map(({name}) => Array.isArray(name) ? name.join("") : name).join('.');
// @ts-ignore
    return {
// @ts-ignore
      kind: "identifier",
// @ts-ignore
      type: "Identifier",
// @ts-ignore
      location: location(),
// @ts-ignore
      segments: segments,
// @ts-ignore
      value: value,
// @ts-ignore
      text: value
    };
  }// @ts-ignore

  function peg$f19(seg) {
// @ts-ignore
    return {
// @ts-ignore
      kind: "identifier",
// @ts-ignore
      value: seg.name,
// @ts-ignore
      text: seg.name,
// @ts-ignore
      type: "Identifier",
// @ts-ignore
      location: location(),
// @ts-ignore
      segments: [seg]
    };
  }// @ts-ignore

  function peg$f20(chars) {
// @ts-ignore
    return {
// @ts-ignore
      type: "IdentifierSegment",
// @ts-ignore
      position: location(),
// @ts-ignore
      name: chars.join("")
    };
  }// @ts-ignore

  function peg$f21(body) {
// @ts-ignore
    return {
// @ts-ignore
      type: "IdentifierSegment",
// @ts-ignore
      position: location(),
// @ts-ignore
      name: "`" + body + "`"
    };
  }// @ts-ignore

  function peg$f22(chars) {
// @ts-ignore
    return chars.join("");
  }// @ts-ignore

  function peg$f23() {
// @ts-ignore
    error("Expected expression after 'and' or 'or'")
  }// @ts-ignore

  function peg$f24(expr, closed) {
// @ts-ignore
    return {
// @ts-ignore
        kind: 'parenthesized-expression',
// @ts-ignore
        expr: expr,
// @ts-ignore
        position: location(),
// @ts-ignore
        text: text(),
// @ts-ignore
        complete: !!closed
    }
  }// @ts-ignore

  function peg$f25(query) {
// @ts-ignore
    return {
// @ts-ignore
      kind: 'search-expression',
// @ts-ignore
      query,
// @ts-ignore
      position: location(),
// @ts-ignore
      text: text(),
// @ts-ignore
      complete: true
    }
  }// @ts-ignore

  function peg$f26(identifier, op, value, finalSpace) {
// @ts-ignore
    const isListValue = value && (value.kind === 'list-expression');
// @ts-ignore
    const isQuotedValue = value && (value.kind === 'quoted-string');
// @ts-ignore
    const hasTrailingSpace = finalSpace && finalSpace.length > 0;

// @ts-ignore
    let isValueComplete = false;

// @ts-ignore
    if (isListValue) {
// @ts-ignore
      isValueComplete = value.complete;
// @ts-ignore
    } else if (isQuotedValue) {
// @ts-ignore
      isValueComplete = value.complete;
// @ts-ignore
    } else {
// @ts-ignore
      isValueComplete = (!!value && hasTrailingSpace);
    }
      
// @ts-ignore
    return {
// @ts-ignore
      kind: 'comparison-expression',
// @ts-ignore
      identifier,
// @ts-ignore
      identifierLocation: identifier.location,
// @ts-ignore
      op: op.value,
// @ts-ignore
      opLocation: op.location,
// @ts-ignore
      value: value === null ? undefined : value,
// @ts-ignore
      valueLocation: value ? value.location : undefined,
// @ts-ignore
      position: location(),
// @ts-ignore
      text: text(),
// @ts-ignore
      complete: isValueComplete,
// @ts-ignore
      context: 'value'
    }
  }// @ts-ignore

  function peg$f27(op) {
// @ts-ignore
    return {
// @ts-ignore
      value: text(),
// @ts-ignore
      location: location()
    }
  }// @ts-ignore

  function peg$f28(identifier, space, op, trail) {
// @ts-ignore
    const operatorLocation = {
// @ts-ignore
      start: { 
// @ts-ignore
        offset: location().start.offset + identifier.value.length + (space ? space.length : 0),
// @ts-ignore
        line: location().start.line,
// @ts-ignore
        column: location().start.column + identifier.value.length + (space ? space.length : 0)
      },
// @ts-ignore
      end: location().end
    };
    
// @ts-ignore
    return {
// @ts-ignore
      kind: 'incomplete-expression',
// @ts-ignore
      identifier,
// @ts-ignore
      identifierLocation: identifier.location,
// @ts-ignore
      op,
// @ts-ignore
      opLocation: operatorLocation,
// @ts-ignore
      value: null,
// @ts-ignore
      position: location(),
// @ts-ignore
      text: text(),
// @ts-ignore
      complete: false,
// @ts-ignore
      context: trail?.length > 0 ? 'value' : space?.length > 0 ? 'operator' : 'field'
    }
  }// @ts-ignore

  function peg$f29(identifier, is, empty) {
// @ts-ignore
    return {
// @ts-ignore
      kind: 'void-expression',
// @ts-ignore
      identifier,
// @ts-ignore
      identifierLocation: identifier.location,
// @ts-ignore
      op: is.value + " " + empty.value,
// @ts-ignore
      opLocation: {
// @ts-ignore
        is: is.location,
// @ts-ignore
        empty: empty.location
      },
// @ts-ignore
      position: location(),
// @ts-ignore
      text: text(),
// @ts-ignore
      complete: true
    }
  }// @ts-ignore

  function peg$f30(identifier, is, nullKeyword) {
// @ts-ignore
    return {
// @ts-ignore
      kind: 'void-expression',
// @ts-ignore
      identifier,
// @ts-ignore
      identifierLocation: identifier.location,
// @ts-ignore
      op: is.value + " " + nullKeyword.value,
// @ts-ignore
      opLocation: {
// @ts-ignore
        is: is.location,
// @ts-ignore
        null: nullKeyword.location
      },
// @ts-ignore
      position: location(),
// @ts-ignore
      text: text(),
// @ts-ignore
      complete: true
    }
  }// @ts-ignore

  function peg$f31(identifier, is, not, nullKeyword) {
// @ts-ignore
    return {
// @ts-ignore
      kind: 'void-expression',
// @ts-ignore
      identifier,
// @ts-ignore
      identifierLocation: identifier.location,
// @ts-ignore
      op: is.value + " " + not.value + " " + nullKeyword.value,
// @ts-ignore
      opLocation: {
// @ts-ignore
        is: is.location,
// @ts-ignore
        not: not.location,
// @ts-ignore
        null: nullKeyword.location
      },
// @ts-ignore
      position: location(),
// @ts-ignore
      text: text(),
// @ts-ignore
      complete: true
    }
  }// @ts-ignore

  function peg$f32(identifier, is, not, empty) {
// @ts-ignore
    return {
// @ts-ignore
      kind: 'void-expression',
// @ts-ignore
      identifier,
// @ts-ignore
      identifierLocation: identifier.location,
// @ts-ignore
      op: is.value + " " + not.value + " " + empty.value,
// @ts-ignore
      opLocation: {
// @ts-ignore
        is: is.location,
// @ts-ignore
        not: not.location,
// @ts-ignore
        empty: empty.location
      },
// @ts-ignore
      position: location(),
// @ts-ignore
      text: text(),
// @ts-ignore
      complete: true
    }
  }// @ts-ignore

  function peg$f33(identifier, op, values, closed) {
// @ts-ignore
    return {
// @ts-ignore
      kind: 'list-expression',
// @ts-ignore
      identifier,
// @ts-ignore
      identifierLocation: identifier.location,
// @ts-ignore
      values: values === null ? undefined : values,
// @ts-ignore
      valuesLocation: values ? {
// @ts-ignore
        start: location().start.offset + text().indexOf('(') + 1,
// @ts-ignore
        end: closed ? location().end.offset - 1 : location().end.offset
// @ts-ignore
      } : undefined,
// @ts-ignore
      position: location(),
// @ts-ignore
      op: op.value,
// @ts-ignore
      opLocation: op.location,
// @ts-ignore
      text: text(),
// @ts-ignore
      complete: !!closed,
// @ts-ignore
      context: 'value'
    }
  }// @ts-ignore

  function peg$f34(identifier, not, inOp, values, closed) {
// @ts-ignore
    return {
// @ts-ignore
      kind: 'list-expression',
// @ts-ignore
      identifier,
// @ts-ignore
      identifierLocation: identifier.location,
// @ts-ignore
      values: values === null ? undefined : values,
// @ts-ignore
      valuesLocation: values ? {
// @ts-ignore
        start: location().start.offset + text().indexOf('(') + 1,
// @ts-ignore
        end: closed ? location().end.offset - 1 : location().end.offset
// @ts-ignore
      } : undefined,
// @ts-ignore
      position: location(),
// @ts-ignore
      op: not.value + " " + inOp.value,
// @ts-ignore
      opLocation: {
// @ts-ignore
        not: not.location,
// @ts-ignore
        in: inOp.location
      },
// @ts-ignore
      text: text(),
// @ts-ignore
      complete: !!closed
    }
  }// @ts-ignore

  function peg$f35(identifier, contains, value, finalSpace) {
// @ts-ignore
    const hasTrailingSpace = finalSpace && finalSpace.length > 0;
// @ts-ignore
    const isValueComplete = value && ((value.kind === 'quoted-key-value' && value.complete) || (value.kind !== 'quoted-key-value' && value.complete && hasTrailingSpace));
    
// @ts-ignore
    return {
// @ts-ignore
      kind: 'contains-expression',
// @ts-ignore
      identifier,
// @ts-ignore
      identifierLocation: identifier.location,
// @ts-ignore
      op: contains.value,
// @ts-ignore
      opLocation: contains.location,
// @ts-ignore
      value: value === null ? undefined : value,
// @ts-ignore
      valueLocation: value ? value.location : undefined,
// @ts-ignore
      position: location(),
// @ts-ignore
      text: text(),
// @ts-ignore
      complete: isValueComplete,
// @ts-ignore
      context: 'value'
    }
  }// @ts-ignore

  function peg$f36(left, and, right) {
// @ts-ignore
    return {
// @ts-ignore
      kind: 'and-expression',
// @ts-ignore
      left,
// @ts-ignore
      right,
// @ts-ignore
      op: and.value,
// @ts-ignore
      opLocation: and.location,
// @ts-ignore
      position: location(),
// @ts-ignore
      text: text(),
// @ts-ignore
      complete: left.complete !== false && right.complete !== false
    }
  }// @ts-ignore

  function peg$f37(left, space, and, space2, right) {
    // This handles the case where there might not be required whitespace
// @ts-ignore
    return {
// @ts-ignore
      kind: 'and-expression',
// @ts-ignore
      left,
// @ts-ignore
      right, 
// @ts-ignore
      op: and.value,
// @ts-ignore
      opLocation: and.location,
// @ts-ignore
      position: location(),
// @ts-ignore
      text: text(),
// @ts-ignore
      complete: left.complete !== false && right.complete !== false
    }
  }// @ts-ignore

  function peg$f38(and) {
// @ts-ignore
    error(`Expected expression after '${and.value}'`)
  }// @ts-ignore

  function peg$f39(left, right) {
// @ts-ignore
    return {
// @ts-ignore
      kind: 'implicit-and-expression',
// @ts-ignore
      left,
// @ts-ignore
      right,
// @ts-ignore
      position: location(),
// @ts-ignore
      text: text(),
// @ts-ignore
      complete: left.complete !== false && right.complete !== false
    }
  }// @ts-ignore

  function peg$f40(left, or, right) {
// @ts-ignore
    return {
// @ts-ignore
      kind: 'or-expression',
// @ts-ignore
      left,
// @ts-ignore
      right,
// @ts-ignore
      op: or.value,
// @ts-ignore
      opLocation: or.location,
// @ts-ignore
      position: location(),
// @ts-ignore
      text: text(),
// @ts-ignore
      complete: left.complete !== false && right.complete !== false
    }
  }// @ts-ignore

  function peg$f41(left, space, or, space2, right) {
    // This handles the case where there might not be required whitespace
// @ts-ignore
    return {
// @ts-ignore
      kind: 'or-expression',
// @ts-ignore
      left,
// @ts-ignore
      right,
// @ts-ignore
      op: or.value,
// @ts-ignore
      opLocation: or.location,
// @ts-ignore
      position: location(),
// @ts-ignore
      text: text(),
// @ts-ignore
      complete: left.complete !== false && right.complete !== false
    }
  }// @ts-ignore

  function peg$f42(or) {
// @ts-ignore
    error(`Expected expression after '${or.value}'`)
  }// @ts-ignore

  function peg$f43(not, space, expression) {
// @ts-ignore
    return {
// @ts-ignore
      kind: 'not-expression',
// @ts-ignore
      expression,
// @ts-ignore
      op: not.value,
// @ts-ignore
      opLocation: not.location,
// @ts-ignore
      position: location(),
// @ts-ignore
      text: text(),
// @ts-ignore
      complete: expression?.complete === true,
// @ts-ignore
      context: expression?.context ?? 'prefix-operator'
    }
  }// @ts-ignore

  function peg$f44() {
// @ts-ignore
    return {
// @ts-ignore
      kind: 'int',
// @ts-ignore
      value: parseInt(text(), 10),
// @ts-ignore
      location: location(),
// @ts-ignore
      text: text(),
    }
  }// @ts-ignore

  function peg$f45() {
// @ts-ignore
    return {
// @ts-ignore
      kind: 'bool',
// @ts-ignore
      value: true,
// @ts-ignore
      location: location(),
// @ts-ignore
      text: text(),
    }
  }// @ts-ignore

  function peg$f46() {
// @ts-ignore
    return {
// @ts-ignore
      kind: 'bool',
// @ts-ignore
      value: false,
// @ts-ignore
      location: location(),
// @ts-ignore
      text: text(),
    }
  }// @ts-ignore

  function peg$f47() {
// @ts-ignore
    return {
// @ts-ignore
      kind: 'float',
// @ts-ignore
      value: parseFloat(text()),
// @ts-ignore
      location: location(),
// @ts-ignore
      text: text(),
    }
  }// @ts-ignore

  function peg$f48() {
// @ts-ignore
    return {
// @ts-ignore
      kind: 'float',
// @ts-ignore
      value: parseFloat(text()),
// @ts-ignore
      location: location(),
// @ts-ignore
      text: text(),
    }
  }
// @ts-ignore
  let peg$currPos = options.peg$currPos | 0;
// @ts-ignore
  let peg$savedPos = peg$currPos;
// @ts-ignore
  const peg$posDetailsCache = [{ line: 1, column: 1 }];
// @ts-ignore
  let peg$maxFailPos = peg$currPos;
// @ts-ignore
  let peg$maxFailExpected = options.peg$maxFailExpected || [];
// @ts-ignore
  let peg$silentFails = options.peg$silentFails | 0;

// @ts-ignore
  let peg$resultsCache = {};

// @ts-ignore
  let peg$result;

// @ts-ignore
  if (options.startRule) {
// @ts-ignore
    if (!(options.startRule in peg$startRuleFunctions)) {
// @ts-ignore
      throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
    }

// @ts-ignore
    peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
  }

// @ts-ignore
  function text() {
// @ts-ignore
    return input.substring(peg$savedPos, peg$currPos);
  }

// @ts-ignore
  function offset() {
// @ts-ignore
    return peg$savedPos;
  }

// @ts-ignore
  function range() {
// @ts-ignore
    return {
// @ts-ignore
      source: peg$source,
// @ts-ignore
      start: peg$savedPos,
// @ts-ignore
      end: peg$currPos,
    };
  }

// @ts-ignore
  function location() {
// @ts-ignore
    return peg$computeLocation(peg$savedPos, peg$currPos);
  }

// @ts-ignore
  function expected(description, location) {
// @ts-ignore
    location = location !== undefined
// @ts-ignore
      ? location
// @ts-ignore
      : peg$computeLocation(peg$savedPos, peg$currPos);

// @ts-ignore
    throw peg$buildStructuredError(
// @ts-ignore
      [peg$otherExpectation(description)],
// @ts-ignore
      input.substring(peg$savedPos, peg$currPos),
// @ts-ignore
      location
    );
  }

// @ts-ignore
  function error(message, location) {
// @ts-ignore
    location = location !== undefined
// @ts-ignore
      ? location
// @ts-ignore
      : peg$computeLocation(peg$savedPos, peg$currPos);

// @ts-ignore
    throw peg$buildSimpleError(message, location);
  }

// @ts-ignore
  function peg$getUnicode(pos = peg$currPos) {
// @ts-ignore
    const cp = input.codePointAt(pos);
// @ts-ignore
    if (cp === undefined) {
// @ts-ignore
      return "";
    }
// @ts-ignore
    return String.fromCodePoint(cp);
  }

// @ts-ignore
  function peg$literalExpectation(text, ignoreCase) {
// @ts-ignore
    return { type: "literal", text, ignoreCase };
  }

// @ts-ignore
  function peg$classExpectation(parts, inverted, ignoreCase, unicode) {
// @ts-ignore
    return { type: "class", parts, inverted, ignoreCase, unicode };
  }

// @ts-ignore
  function peg$anyExpectation() {
// @ts-ignore
    return { type: "any" };
  }

// @ts-ignore
  function peg$endExpectation() {
// @ts-ignore
    return { type: "end" };
  }

// @ts-ignore
  function peg$otherExpectation(description) {
// @ts-ignore
    return { type: "other", description };
  }

// @ts-ignore
  function peg$computePosDetails(pos) {
// @ts-ignore
    let details = peg$posDetailsCache[pos];
// @ts-ignore
    let p;

// @ts-ignore
    if (details) {
// @ts-ignore
      return details;
// @ts-ignore
    } else {
// @ts-ignore
      if (pos >= peg$posDetailsCache.length) {
// @ts-ignore
        p = peg$posDetailsCache.length - 1;
// @ts-ignore
      } else {
// @ts-ignore
        p = pos;
// @ts-ignore
        while (!peg$posDetailsCache[--p]) {}
      }

// @ts-ignore
      details = peg$posDetailsCache[p];
// @ts-ignore
      details = {
// @ts-ignore
        line: details.line,
// @ts-ignore
        column: details.column,
      };

// @ts-ignore
      while (p < pos) {
// @ts-ignore
        if (input.charCodeAt(p) === 10) {
// @ts-ignore
          details.line++;
// @ts-ignore
          details.column = 1;
// @ts-ignore
        } else {
// @ts-ignore
          details.column++;
        }

// @ts-ignore
        p++;
      }

// @ts-ignore
      peg$posDetailsCache[pos] = details;

// @ts-ignore
      return details;
    }
  }

// @ts-ignore
  function peg$computeLocation(startPos, endPos, offset) {
// @ts-ignore
    const startPosDetails = peg$computePosDetails(startPos);
// @ts-ignore
    const endPosDetails = peg$computePosDetails(endPos);

// @ts-ignore
    const res = {
// @ts-ignore
      source: peg$source,
// @ts-ignore
      start: {
// @ts-ignore
        offset: startPos,
// @ts-ignore
        line: startPosDetails.line,
// @ts-ignore
        column: startPosDetails.column,
      },
// @ts-ignore
      end: {
// @ts-ignore
        offset: endPos,
// @ts-ignore
        line: endPosDetails.line,
// @ts-ignore
        column: endPosDetails.column,
      },
    };
// @ts-ignore
    if (offset && peg$source && (typeof peg$source.offset === "function")) {
// @ts-ignore
      res.start = peg$source.offset(res.start);
// @ts-ignore
      res.end = peg$source.offset(res.end);
    }
// @ts-ignore
    return res;
  }

// @ts-ignore
  function peg$fail(expected) {
// @ts-ignore
    if (peg$currPos < peg$maxFailPos) { return; }

// @ts-ignore
    if (peg$currPos > peg$maxFailPos) {
// @ts-ignore
      peg$maxFailPos = peg$currPos;
// @ts-ignore
      peg$maxFailExpected = [];
    }

// @ts-ignore
    peg$maxFailExpected.push(expected);
  }

// @ts-ignore
  function peg$buildSimpleError(message, location) {
// @ts-ignore
    return new peg$SyntaxError(message, null, null, location);
  }

// @ts-ignore
  function peg$buildStructuredError(expected, found, location) {
// @ts-ignore
    return new peg$SyntaxError(
// @ts-ignore
      peg$SyntaxError.buildMessage(expected, found),
// @ts-ignore
      expected,
// @ts-ignore
      found,
// @ts-ignore
      location
    );
  }

// @ts-ignore
  function // @ts-ignore
peg$parseFilter() {
// @ts-ignore
    let s0, s1, s2, s3, s4;

// @ts-ignore
    const key = peg$currPos * 41 + 0;
// @ts-ignore
    const cached = peg$resultsCache[key];

// @ts-ignore
    if (cached) {
// @ts-ignore
      peg$currPos = cached.nextPos;

// @ts-ignore
      return cached.result;
    }

// @ts-ignore
    s0 = peg$currPos;
// @ts-ignore
    s1 = peg$parse_();
// @ts-ignore
    s2 = peg$parseExpression();
// @ts-ignore
    if (s2 === peg$FAILED) {
// @ts-ignore
      s2 = null;
    }
// @ts-ignore
    s3 = peg$parse_();
// @ts-ignore
    s4 = peg$parseEOF();
// @ts-ignore
    if (s4 !== peg$FAILED) {
// @ts-ignore
      peg$savedPos = s0;
// @ts-ignore
      s0 = peg$f0(s2);
// @ts-ignore
    } else {
// @ts-ignore
      peg$currPos = s0;
// @ts-ignore
      s0 = peg$FAILED;
    }

// @ts-ignore
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

// @ts-ignore
    return s0;
  }

// @ts-ignore
  function // @ts-ignore
peg$parseKeyword() {
// @ts-ignore
    let s0, s1, s2, s3;

// @ts-ignore
    const key = peg$currPos * 41 + 1;
// @ts-ignore
    const cached = peg$resultsCache[key];

// @ts-ignore
    if (cached) {
// @ts-ignore
      peg$currPos = cached.nextPos;

// @ts-ignore
      return cached.result;
    }

// @ts-ignore
    s0 = peg$currPos;
// @ts-ignore
    s1 = input.substr(peg$currPos, 3);
// @ts-ignore
    if (s1.toLowerCase() === peg$c0) {
// @ts-ignore
      peg$currPos += (3);
// @ts-ignore
    } else {
// @ts-ignore
      s1 = peg$FAILED;
// @ts-ignore
      if (peg$silentFails === 0) { peg$fail(peg$e0); }
    }
// @ts-ignore
    if (s1 === peg$FAILED) {
// @ts-ignore
      s1 = input.substr(peg$currPos, 2);
// @ts-ignore
      if (s1.toLowerCase() === peg$c1) {
// @ts-ignore
        peg$currPos += (2);
// @ts-ignore
      } else {
// @ts-ignore
        s1 = peg$FAILED;
// @ts-ignore
        if (peg$silentFails === 0) { peg$fail(peg$e1); }
      }
// @ts-ignore
      if (s1 === peg$FAILED) {
// @ts-ignore
        s1 = input.substr(peg$currPos, 3);
// @ts-ignore
        if (s1.toLowerCase() === peg$c2) {
// @ts-ignore
          peg$currPos += (3);
// @ts-ignore
        } else {
// @ts-ignore
          s1 = peg$FAILED;
// @ts-ignore
          if (peg$silentFails === 0) { peg$fail(peg$e2); }
        }
// @ts-ignore
        if (s1 === peg$FAILED) {
// @ts-ignore
          s1 = input.substr(peg$currPos, 8);
// @ts-ignore
          if (s1.toLowerCase() === peg$c3) {
// @ts-ignore
            peg$currPos += (8);
// @ts-ignore
          } else {
// @ts-ignore
            s1 = peg$FAILED;
// @ts-ignore
            if (peg$silentFails === 0) { peg$fail(peg$e3); }
          }
// @ts-ignore
          if (s1 === peg$FAILED) {
// @ts-ignore
            s1 = input.substr(peg$currPos, 4);
// @ts-ignore
            if (s1.toLowerCase() === peg$c4) {
// @ts-ignore
              peg$currPos += (4);
// @ts-ignore
            } else {
// @ts-ignore
              s1 = peg$FAILED;
// @ts-ignore
              if (peg$silentFails === 0) { peg$fail(peg$e4); }
            }
// @ts-ignore
            if (s1 === peg$FAILED) {
// @ts-ignore
              s1 = input.substr(peg$currPos, 2);
// @ts-ignore
              if (s1.toLowerCase() === peg$c5) {
// @ts-ignore
                peg$currPos += (2);
// @ts-ignore
              } else {
// @ts-ignore
                s1 = peg$FAILED;
// @ts-ignore
                if (peg$silentFails === 0) { peg$fail(peg$e5); }
              }
// @ts-ignore
              if (s1 === peg$FAILED) {
// @ts-ignore
                s1 = input.substr(peg$currPos, 5);
// @ts-ignore
                if (s1.toLowerCase() === peg$c6) {
// @ts-ignore
                  peg$currPos += (5);
// @ts-ignore
                } else {
// @ts-ignore
                  s1 = peg$FAILED;
// @ts-ignore
                  if (peg$silentFails === 0) { peg$fail(peg$e6); }
                }
// @ts-ignore
                if (s1 === peg$FAILED) {
// @ts-ignore
                  s1 = input.substr(peg$currPos, 2);
// @ts-ignore
                  if (s1.toLowerCase() === peg$c7) {
// @ts-ignore
                    peg$currPos += (2);
// @ts-ignore
                  } else {
// @ts-ignore
                    s1 = peg$FAILED;
// @ts-ignore
                    if (peg$silentFails === 0) { peg$fail(peg$e7); }
                  }
                }
              }
            }
          }
        }
      }
    }
// @ts-ignore
    if (s1 !== peg$FAILED) {
// @ts-ignore
      s2 = peg$currPos;
// @ts-ignore
      peg$silentFails++;
// @ts-ignore
      s3 = input.charAt(peg$currPos);
// @ts-ignore
      if (peg$r0.test(s3)) {
// @ts-ignore
        peg$currPos++;
// @ts-ignore
      } else {
// @ts-ignore
        s3 = peg$FAILED;
// @ts-ignore
        if (peg$silentFails === 0) { peg$fail(peg$e8); }
      }
// @ts-ignore
      peg$silentFails--;
// @ts-ignore
      if (s3 === peg$FAILED) {
// @ts-ignore
        s2 = undefined;
// @ts-ignore
      } else {
// @ts-ignore
        peg$currPos = s2;
// @ts-ignore
        s2 = peg$FAILED;
      }
// @ts-ignore
      if (s2 !== peg$FAILED) {
// @ts-ignore
        s1 = [s1, s2];
// @ts-ignore
        s0 = s1;
// @ts-ignore
      } else {
// @ts-ignore
        peg$currPos = s0;
// @ts-ignore
        s0 = peg$FAILED;
      }
// @ts-ignore
    } else {
// @ts-ignore
      peg$currPos = s0;
// @ts-ignore
      s0 = peg$FAILED;
    }

// @ts-ignore
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

// @ts-ignore
    return s0;
  }

// @ts-ignore
  function // @ts-ignore
peg$parseKeywordNot() {
// @ts-ignore
    let s0, s1, s2, s3;

// @ts-ignore
    const key = peg$currPos * 41 + 2;
// @ts-ignore
    const cached = peg$resultsCache[key];

// @ts-ignore
    if (cached) {
// @ts-ignore
      peg$currPos = cached.nextPos;

// @ts-ignore
      return cached.result;
    }

// @ts-ignore
    s0 = peg$currPos;
// @ts-ignore
    s1 = input.substr(peg$currPos, 3);
// @ts-ignore
    if (s1.toLowerCase() === peg$c2) {
// @ts-ignore
      peg$currPos += (3);
// @ts-ignore
    } else {
// @ts-ignore
      s1 = peg$FAILED;
// @ts-ignore
      if (peg$silentFails === 0) { peg$fail(peg$e2); }
    }
// @ts-ignore
    if (s1 !== peg$FAILED) {
// @ts-ignore
      s2 = peg$currPos;
// @ts-ignore
      peg$silentFails++;
// @ts-ignore
      s3 = input.charAt(peg$currPos);
// @ts-ignore
      if (peg$r0.test(s3)) {
// @ts-ignore
        peg$currPos++;
// @ts-ignore
      } else {
// @ts-ignore
        s3 = peg$FAILED;
// @ts-ignore
        if (peg$silentFails === 0) { peg$fail(peg$e8); }
      }
// @ts-ignore
      peg$silentFails--;
// @ts-ignore
      if (s3 === peg$FAILED) {
// @ts-ignore
        s2 = undefined;
// @ts-ignore
      } else {
// @ts-ignore
        peg$currPos = s2;
// @ts-ignore
        s2 = peg$FAILED;
      }
// @ts-ignore
      if (s2 !== peg$FAILED) {
// @ts-ignore
        peg$savedPos = s0;
// @ts-ignore
        s0 = peg$f1(s1);
// @ts-ignore
      } else {
// @ts-ignore
        peg$currPos = s0;
// @ts-ignore
        s0 = peg$FAILED;
      }
// @ts-ignore
    } else {
// @ts-ignore
      peg$currPos = s0;
// @ts-ignore
      s0 = peg$FAILED;
    }

// @ts-ignore
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

// @ts-ignore
    return s0;
  }

// @ts-ignore
  function // @ts-ignore
peg$parseKeywordIn() {
// @ts-ignore
    let s0, s1, s2, s3;

// @ts-ignore
    const key = peg$currPos * 41 + 3;
// @ts-ignore
    const cached = peg$resultsCache[key];

// @ts-ignore
    if (cached) {
// @ts-ignore
      peg$currPos = cached.nextPos;

// @ts-ignore
      return cached.result;
    }

// @ts-ignore
    s0 = peg$currPos;
// @ts-ignore
    s1 = input.substr(peg$currPos, 2);
// @ts-ignore
    if (s1.toLowerCase() === peg$c7) {
// @ts-ignore
      peg$currPos += (2);
// @ts-ignore
    } else {
// @ts-ignore
      s1 = peg$FAILED;
// @ts-ignore
      if (peg$silentFails === 0) { peg$fail(peg$e7); }
    }
// @ts-ignore
    if (s1 !== peg$FAILED) {
// @ts-ignore
      s2 = peg$currPos;
// @ts-ignore
      peg$silentFails++;
// @ts-ignore
      s3 = input.charAt(peg$currPos);
// @ts-ignore
      if (peg$r0.test(s3)) {
// @ts-ignore
        peg$currPos++;
// @ts-ignore
      } else {
// @ts-ignore
        s3 = peg$FAILED;
// @ts-ignore
        if (peg$silentFails === 0) { peg$fail(peg$e8); }
      }
// @ts-ignore
      peg$silentFails--;
// @ts-ignore
      if (s3 === peg$FAILED) {
// @ts-ignore
        s2 = undefined;
// @ts-ignore
      } else {
// @ts-ignore
        peg$currPos = s2;
// @ts-ignore
        s2 = peg$FAILED;
      }
// @ts-ignore
      if (s2 !== peg$FAILED) {
// @ts-ignore
        peg$savedPos = s0;
// @ts-ignore
        s0 = peg$f2(s1);
// @ts-ignore
      } else {
// @ts-ignore
        peg$currPos = s0;
// @ts-ignore
        s0 = peg$FAILED;
      }
// @ts-ignore
    } else {
// @ts-ignore
      peg$currPos = s0;
// @ts-ignore
      s0 = peg$FAILED;
    }

// @ts-ignore
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

// @ts-ignore
    return s0;
  }

// @ts-ignore
  function // @ts-ignore
peg$parseKeywordIs() {
// @ts-ignore
    let s0, s1, s2, s3;

// @ts-ignore
    const key = peg$currPos * 41 + 4;
// @ts-ignore
    const cached = peg$resultsCache[key];

// @ts-ignore
    if (cached) {
// @ts-ignore
      peg$currPos = cached.nextPos;

// @ts-ignore
      return cached.result;
    }

// @ts-ignore
    s0 = peg$currPos;
// @ts-ignore
    s1 = input.substr(peg$currPos, 2);
// @ts-ignore
    if (s1.toLowerCase() === peg$c5) {
// @ts-ignore
      peg$currPos += (2);
// @ts-ignore
    } else {
// @ts-ignore
      s1 = peg$FAILED;
// @ts-ignore
      if (peg$silentFails === 0) { peg$fail(peg$e5); }
    }
// @ts-ignore
    if (s1 !== peg$FAILED) {
// @ts-ignore
      s2 = peg$currPos;
// @ts-ignore
      peg$silentFails++;
// @ts-ignore
      s3 = input.charAt(peg$currPos);
// @ts-ignore
      if (peg$r0.test(s3)) {
// @ts-ignore
        peg$currPos++;
// @ts-ignore
      } else {
// @ts-ignore
        s3 = peg$FAILED;
// @ts-ignore
        if (peg$silentFails === 0) { peg$fail(peg$e8); }
      }
// @ts-ignore
      peg$silentFails--;
// @ts-ignore
      if (s3 === peg$FAILED) {
// @ts-ignore
        s2 = undefined;
// @ts-ignore
      } else {
// @ts-ignore
        peg$currPos = s2;
// @ts-ignore
        s2 = peg$FAILED;
      }
// @ts-ignore
      if (s2 !== peg$FAILED) {
// @ts-ignore
        peg$savedPos = s0;
// @ts-ignore
        s0 = peg$f3(s1);
// @ts-ignore
      } else {
// @ts-ignore
        peg$currPos = s0;
// @ts-ignore
        s0 = peg$FAILED;
      }
// @ts-ignore
    } else {
// @ts-ignore
      peg$currPos = s0;
// @ts-ignore
      s0 = peg$FAILED;
    }

// @ts-ignore
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

// @ts-ignore
    return s0;
  }

// @ts-ignore
  function // @ts-ignore
peg$parseKeywordNull() {
// @ts-ignore
    let s0, s1, s2, s3;

// @ts-ignore
    const key = peg$currPos * 41 + 5;
// @ts-ignore
    const cached = peg$resultsCache[key];

// @ts-ignore
    if (cached) {
// @ts-ignore
      peg$currPos = cached.nextPos;

// @ts-ignore
      return cached.result;
    }

// @ts-ignore
    s0 = peg$currPos;
// @ts-ignore
    s1 = input.substr(peg$currPos, 4);
// @ts-ignore
    if (s1.toLowerCase() === peg$c4) {
// @ts-ignore
      peg$currPos += (4);
// @ts-ignore
    } else {
// @ts-ignore
      s1 = peg$FAILED;
// @ts-ignore
      if (peg$silentFails === 0) { peg$fail(peg$e4); }
    }
// @ts-ignore
    if (s1 !== peg$FAILED) {
// @ts-ignore
      s2 = peg$currPos;
// @ts-ignore
      peg$silentFails++;
// @ts-ignore
      s3 = input.charAt(peg$currPos);
// @ts-ignore
      if (peg$r0.test(s3)) {
// @ts-ignore
        peg$currPos++;
// @ts-ignore
      } else {
// @ts-ignore
        s3 = peg$FAILED;
// @ts-ignore
        if (peg$silentFails === 0) { peg$fail(peg$e8); }
      }
// @ts-ignore
      peg$silentFails--;
// @ts-ignore
      if (s3 === peg$FAILED) {
// @ts-ignore
        s2 = undefined;
// @ts-ignore
      } else {
// @ts-ignore
        peg$currPos = s2;
// @ts-ignore
        s2 = peg$FAILED;
      }
// @ts-ignore
      if (s2 !== peg$FAILED) {
// @ts-ignore
        peg$savedPos = s0;
// @ts-ignore
        s0 = peg$f4(s1);
// @ts-ignore
      } else {
// @ts-ignore
        peg$currPos = s0;
// @ts-ignore
        s0 = peg$FAILED;
      }
// @ts-ignore
    } else {
// @ts-ignore
      peg$currPos = s0;
// @ts-ignore
      s0 = peg$FAILED;
    }

// @ts-ignore
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

// @ts-ignore
    return s0;
  }

// @ts-ignore
  function // @ts-ignore
peg$parseKeywordContains() {
// @ts-ignore
    let s0, s1, s2, s3;

// @ts-ignore
    const key = peg$currPos * 41 + 6;
// @ts-ignore
    const cached = peg$resultsCache[key];

// @ts-ignore
    if (cached) {
// @ts-ignore
      peg$currPos = cached.nextPos;

// @ts-ignore
      return cached.result;
    }

// @ts-ignore
    s0 = peg$currPos;
// @ts-ignore
    s1 = input.substr(peg$currPos, 8);
// @ts-ignore
    if (s1.toLowerCase() === peg$c3) {
// @ts-ignore
      peg$currPos += (8);
// @ts-ignore
    } else {
// @ts-ignore
      s1 = peg$FAILED;
// @ts-ignore
      if (peg$silentFails === 0) { peg$fail(peg$e3); }
    }
// @ts-ignore
    if (s1 !== peg$FAILED) {
// @ts-ignore
      s2 = peg$currPos;
// @ts-ignore
      peg$silentFails++;
// @ts-ignore
      s3 = input.charAt(peg$currPos);
// @ts-ignore
      if (peg$r0.test(s3)) {
// @ts-ignore
        peg$currPos++;
// @ts-ignore
      } else {
// @ts-ignore
        s3 = peg$FAILED;
// @ts-ignore
        if (peg$silentFails === 0) { peg$fail(peg$e8); }
      }
// @ts-ignore
      peg$silentFails--;
// @ts-ignore
      if (s3 === peg$FAILED) {
// @ts-ignore
        s2 = undefined;
// @ts-ignore
      } else {
// @ts-ignore
        peg$currPos = s2;
// @ts-ignore
        s2 = peg$FAILED;
      }
// @ts-ignore
      if (s2 !== peg$FAILED) {
// @ts-ignore
        peg$savedPos = s0;
// @ts-ignore
        s0 = peg$f5(s1);
// @ts-ignore
      } else {
// @ts-ignore
        peg$currPos = s0;
// @ts-ignore
        s0 = peg$FAILED;
      }
// @ts-ignore
    } else {
// @ts-ignore
      peg$currPos = s0;
// @ts-ignore
      s0 = peg$FAILED;
    }

// @ts-ignore
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

// @ts-ignore
    return s0;
  }

// @ts-ignore
  function // @ts-ignore
peg$parseKeywordEmpty() {
// @ts-ignore
    let s0, s1, s2, s3;

// @ts-ignore
    const key = peg$currPos * 41 + 7;
// @ts-ignore
    const cached = peg$resultsCache[key];

// @ts-ignore
    if (cached) {
// @ts-ignore
      peg$currPos = cached.nextPos;

// @ts-ignore
      return cached.result;
    }

// @ts-ignore
    s0 = peg$currPos;
// @ts-ignore
    s1 = input.substr(peg$currPos, 5);
// @ts-ignore
    if (s1.toLowerCase() === peg$c6) {
// @ts-ignore
      peg$currPos += (5);
// @ts-ignore
    } else {
// @ts-ignore
      s1 = peg$FAILED;
// @ts-ignore
      if (peg$silentFails === 0) { peg$fail(peg$e6); }
    }
// @ts-ignore
    if (s1 !== peg$FAILED) {
// @ts-ignore
      s2 = peg$currPos;
// @ts-ignore
      peg$silentFails++;
// @ts-ignore
      s3 = input.charAt(peg$currPos);
// @ts-ignore
      if (peg$r0.test(s3)) {
// @ts-ignore
        peg$currPos++;
// @ts-ignore
      } else {
// @ts-ignore
        s3 = peg$FAILED;
// @ts-ignore
        if (peg$silentFails === 0) { peg$fail(peg$e8); }
      }
// @ts-ignore
      peg$silentFails--;
// @ts-ignore
      if (s3 === peg$FAILED) {
// @ts-ignore
        s2 = undefined;
// @ts-ignore
      } else {
// @ts-ignore
        peg$currPos = s2;
// @ts-ignore
        s2 = peg$FAILED;
      }
// @ts-ignore
      if (s2 !== peg$FAILED) {
// @ts-ignore
        peg$savedPos = s0;
// @ts-ignore
        s0 = peg$f6(s1);
// @ts-ignore
      } else {
// @ts-ignore
        peg$currPos = s0;
// @ts-ignore
        s0 = peg$FAILED;
      }
// @ts-ignore
    } else {
// @ts-ignore
      peg$currPos = s0;
// @ts-ignore
      s0 = peg$FAILED;
    }

// @ts-ignore
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

// @ts-ignore
    return s0;
  }

// @ts-ignore
  function // @ts-ignore
peg$parseKeywordAnd() {
// @ts-ignore
    let s0, s1, s2, s3;

// @ts-ignore
    const key = peg$currPos * 41 + 8;
// @ts-ignore
    const cached = peg$resultsCache[key];

// @ts-ignore
    if (cached) {
// @ts-ignore
      peg$currPos = cached.nextPos;

// @ts-ignore
      return cached.result;
    }

// @ts-ignore
    s0 = peg$currPos;
// @ts-ignore
    s1 = input.substr(peg$currPos, 3);
// @ts-ignore
    if (s1.toLowerCase() === peg$c0) {
// @ts-ignore
      peg$currPos += (3);
// @ts-ignore
    } else {
// @ts-ignore
      s1 = peg$FAILED;
// @ts-ignore
      if (peg$silentFails === 0) { peg$fail(peg$e0); }
    }
// @ts-ignore
    if (s1 !== peg$FAILED) {
// @ts-ignore
      s2 = peg$currPos;
// @ts-ignore
      peg$silentFails++;
// @ts-ignore
      s3 = input.charAt(peg$currPos);
// @ts-ignore
      if (peg$r0.test(s3)) {
// @ts-ignore
        peg$currPos++;
// @ts-ignore
      } else {
// @ts-ignore
        s3 = peg$FAILED;
// @ts-ignore
        if (peg$silentFails === 0) { peg$fail(peg$e8); }
      }
// @ts-ignore
      peg$silentFails--;
// @ts-ignore
      if (s3 === peg$FAILED) {
// @ts-ignore
        s2 = undefined;
// @ts-ignore
      } else {
// @ts-ignore
        peg$currPos = s2;
// @ts-ignore
        s2 = peg$FAILED;
      }
// @ts-ignore
      if (s2 !== peg$FAILED) {
// @ts-ignore
        peg$savedPos = s0;
// @ts-ignore
        s0 = peg$f7(s1);
// @ts-ignore
      } else {
// @ts-ignore
        peg$currPos = s0;
// @ts-ignore
        s0 = peg$FAILED;
      }
// @ts-ignore
    } else {
// @ts-ignore
      peg$currPos = s0;
// @ts-ignore
      s0 = peg$FAILED;
    }

// @ts-ignore
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

// @ts-ignore
    return s0;
  }

// @ts-ignore
  function // @ts-ignore
peg$parseKeywordOr() {
// @ts-ignore
    let s0, s1, s2, s3;

// @ts-ignore
    const key = peg$currPos * 41 + 9;
// @ts-ignore
    const cached = peg$resultsCache[key];

// @ts-ignore
    if (cached) {
// @ts-ignore
      peg$currPos = cached.nextPos;

// @ts-ignore
      return cached.result;
    }

// @ts-ignore
    s0 = peg$currPos;
// @ts-ignore
    s1 = input.substr(peg$currPos, 2);
// @ts-ignore
    if (s1.toLowerCase() === peg$c1) {
// @ts-ignore
      peg$currPos += (2);
// @ts-ignore
    } else {
// @ts-ignore
      s1 = peg$FAILED;
// @ts-ignore
      if (peg$silentFails === 0) { peg$fail(peg$e1); }
    }
// @ts-ignore
    if (s1 !== peg$FAILED) {
// @ts-ignore
      s2 = peg$currPos;
// @ts-ignore
      peg$silentFails++;
// @ts-ignore
      s3 = input.charAt(peg$currPos);
// @ts-ignore
      if (peg$r0.test(s3)) {
// @ts-ignore
        peg$currPos++;
// @ts-ignore
      } else {
// @ts-ignore
        s3 = peg$FAILED;
// @ts-ignore
        if (peg$silentFails === 0) { peg$fail(peg$e8); }
      }
// @ts-ignore
      peg$silentFails--;
// @ts-ignore
      if (s3 === peg$FAILED) {
// @ts-ignore
        s2 = undefined;
// @ts-ignore
      } else {
// @ts-ignore
        peg$currPos = s2;
// @ts-ignore
        s2 = peg$FAILED;
      }
// @ts-ignore
      if (s2 !== peg$FAILED) {
// @ts-ignore
        peg$savedPos = s0;
// @ts-ignore
        s0 = peg$f8(s1);
// @ts-ignore
      } else {
// @ts-ignore
        peg$currPos = s0;
// @ts-ignore
        s0 = peg$FAILED;
      }
// @ts-ignore
    } else {
// @ts-ignore
      peg$currPos = s0;
// @ts-ignore
      s0 = peg$FAILED;
    }

// @ts-ignore
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

// @ts-ignore
    return s0;
  }

// @ts-ignore
  function // @ts-ignore
peg$parseRawString() {
// @ts-ignore
    let s0, s1, s2, s3, s4, s5, s6;

// @ts-ignore
    const key = peg$currPos * 41 + 10;
// @ts-ignore
    const cached = peg$resultsCache[key];

// @ts-ignore
    if (cached) {
// @ts-ignore
      peg$currPos = cached.nextPos;

// @ts-ignore
      return cached.result;
    }

// @ts-ignore
    s0 = peg$currPos;
// @ts-ignore
    s1 = peg$currPos;
// @ts-ignore
    peg$silentFails++;
// @ts-ignore
    s2 = peg$parseKeyword();
// @ts-ignore
    peg$silentFails--;
// @ts-ignore
    if (s2 === peg$FAILED) {
// @ts-ignore
      s1 = undefined;
// @ts-ignore
    } else {
// @ts-ignore
      peg$currPos = s1;
// @ts-ignore
      s1 = peg$FAILED;
    }
// @ts-ignore
    if (s1 !== peg$FAILED) {
// @ts-ignore
      s2 = peg$currPos;
// @ts-ignore
      s3 = peg$currPos;
// @ts-ignore
      s4 = input.charAt(peg$currPos);
// @ts-ignore
      if (peg$r1.test(s4)) {
// @ts-ignore
        peg$currPos++;
// @ts-ignore
      } else {
// @ts-ignore
        s4 = peg$FAILED;
// @ts-ignore
        if (peg$silentFails === 0) { peg$fail(peg$e9); }
      }
// @ts-ignore
      if (s4 !== peg$FAILED) {
// @ts-ignore
        s5 = [];
// @ts-ignore
        s6 = input.charAt(peg$currPos);
// @ts-ignore
        if (peg$r2.test(s6)) {
// @ts-ignore
          peg$currPos++;
// @ts-ignore
        } else {
// @ts-ignore
          s6 = peg$FAILED;
// @ts-ignore
          if (peg$silentFails === 0) { peg$fail(peg$e10); }
        }
// @ts-ignore
        while (s6 !== peg$FAILED) {
// @ts-ignore
          s5.push(s6);
// @ts-ignore
          s6 = input.charAt(peg$currPos);
// @ts-ignore
          if (peg$r2.test(s6)) {
// @ts-ignore
            peg$currPos++;
// @ts-ignore
          } else {
// @ts-ignore
            s6 = peg$FAILED;
// @ts-ignore
            if (peg$silentFails === 0) { peg$fail(peg$e10); }
          }
        }
// @ts-ignore
        s4 = [s4, s5];
// @ts-ignore
        s3 = s4;
// @ts-ignore
      } else {
// @ts-ignore
        peg$currPos = s3;
// @ts-ignore
        s3 = peg$FAILED;
      }
// @ts-ignore
      if (s3 !== peg$FAILED) {
// @ts-ignore
        s2 = input.substring(s2, peg$currPos);
// @ts-ignore
      } else {
// @ts-ignore
        s2 = s3;
      }
// @ts-ignore
      if (s2 !== peg$FAILED) {
// @ts-ignore
        peg$savedPos = s0;
// @ts-ignore
        s0 = peg$f9(s2);
// @ts-ignore
      } else {
// @ts-ignore
        peg$currPos = s0;
// @ts-ignore
        s0 = peg$FAILED;
      }
// @ts-ignore
    } else {
// @ts-ignore
      peg$currPos = s0;
// @ts-ignore
      s0 = peg$FAILED;
    }

// @ts-ignore
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

// @ts-ignore
    return s0;
  }

// @ts-ignore
  function // @ts-ignore
peg$parseQuotedString() {
// @ts-ignore
    let s0, s1, s2, s3, s4;

// @ts-ignore
    const key = peg$currPos * 41 + 11;
// @ts-ignore
    const cached = peg$resultsCache[key];

// @ts-ignore
    if (cached) {
// @ts-ignore
      peg$currPos = cached.nextPos;

// @ts-ignore
      return cached.result;
    }

// @ts-ignore
    s0 = peg$currPos;
// @ts-ignore
    if (input.charCodeAt(peg$currPos) === 34) {
// @ts-ignore
      s1 = peg$c8;
// @ts-ignore
      peg$currPos++;
// @ts-ignore
    } else {
// @ts-ignore
      s1 = peg$FAILED;
// @ts-ignore
      if (peg$silentFails === 0) { peg$fail(peg$e11); }
    }
// @ts-ignore
    if (s1 !== peg$FAILED) {
// @ts-ignore
      s2 = peg$currPos;
// @ts-ignore
      s3 = [];
// @ts-ignore
      s4 = input.charAt(peg$currPos);
// @ts-ignore
      if (peg$r3.test(s4)) {
// @ts-ignore
        peg$currPos++;
// @ts-ignore
      } else {
// @ts-ignore
        s4 = peg$FAILED;
// @ts-ignore
        if (peg$silentFails === 0) { peg$fail(peg$e12); }
      }
// @ts-ignore
      while (s4 !== peg$FAILED) {
// @ts-ignore
        s3.push(s4);
// @ts-ignore
        s4 = input.charAt(peg$currPos);
// @ts-ignore
        if (peg$r3.test(s4)) {
// @ts-ignore
          peg$currPos++;
// @ts-ignore
        } else {
// @ts-ignore
          s4 = peg$FAILED;
// @ts-ignore
          if (peg$silentFails === 0) { peg$fail(peg$e12); }
        }
      }
// @ts-ignore
      s2 = input.substring(s2, peg$currPos);
// @ts-ignore
      if (input.charCodeAt(peg$currPos) === 34) {
// @ts-ignore
        s3 = peg$c8;
// @ts-ignore
        peg$currPos++;
// @ts-ignore
      } else {
// @ts-ignore
        s3 = peg$FAILED;
// @ts-ignore
        if (peg$silentFails === 0) { peg$fail(peg$e11); }
      }
// @ts-ignore
      if (s3 !== peg$FAILED) {
// @ts-ignore
        peg$savedPos = s0;
// @ts-ignore
        s0 = peg$f10(s2);
// @ts-ignore
      } else {
// @ts-ignore
        peg$currPos = s0;
// @ts-ignore
        s0 = peg$FAILED;
      }
// @ts-ignore
    } else {
// @ts-ignore
      peg$currPos = s0;
// @ts-ignore
      s0 = peg$FAILED;
    }
// @ts-ignore
    if (s0 === peg$FAILED) {
// @ts-ignore
      s0 = peg$currPos;
// @ts-ignore
      if (input.charCodeAt(peg$currPos) === 34) {
// @ts-ignore
        s1 = peg$c8;
// @ts-ignore
        peg$currPos++;
// @ts-ignore
      } else {
// @ts-ignore
        s1 = peg$FAILED;
// @ts-ignore
        if (peg$silentFails === 0) { peg$fail(peg$e11); }
      }
// @ts-ignore
      if (s1 !== peg$FAILED) {
// @ts-ignore
        s2 = peg$currPos;
// @ts-ignore
        s3 = [];
// @ts-ignore
        s4 = input.charAt(peg$currPos);
// @ts-ignore
        if (peg$r3.test(s4)) {
// @ts-ignore
          peg$currPos++;
// @ts-ignore
        } else {
// @ts-ignore
          s4 = peg$FAILED;
// @ts-ignore
          if (peg$silentFails === 0) { peg$fail(peg$e12); }
        }
// @ts-ignore
        while (s4 !== peg$FAILED) {
// @ts-ignore
          s3.push(s4);
// @ts-ignore
          s4 = input.charAt(peg$currPos);
// @ts-ignore
          if (peg$r3.test(s4)) {
// @ts-ignore
            peg$currPos++;
// @ts-ignore
          } else {
// @ts-ignore
            s4 = peg$FAILED;
// @ts-ignore
            if (peg$silentFails === 0) { peg$fail(peg$e12); }
          }
        }
// @ts-ignore
        s2 = input.substring(s2, peg$currPos);
// @ts-ignore
        s3 = peg$currPos;
// @ts-ignore
        peg$silentFails++;
// @ts-ignore
        if (input.charCodeAt(peg$currPos) === 34) {
// @ts-ignore
          s4 = peg$c8;
// @ts-ignore
          peg$currPos++;
// @ts-ignore
        } else {
// @ts-ignore
          s4 = peg$FAILED;
// @ts-ignore
          if (peg$silentFails === 0) { peg$fail(peg$e11); }
        }
// @ts-ignore
        peg$silentFails--;
// @ts-ignore
        if (s4 === peg$FAILED) {
// @ts-ignore
          s3 = undefined;
// @ts-ignore
        } else {
// @ts-ignore
          peg$currPos = s3;
// @ts-ignore
          s3 = peg$FAILED;
        }
// @ts-ignore
        if (s3 !== peg$FAILED) {
// @ts-ignore
          peg$savedPos = s0;
// @ts-ignore
          s0 = peg$f11(s2);
// @ts-ignore
        } else {
// @ts-ignore
          peg$currPos = s0;
// @ts-ignore
          s0 = peg$FAILED;
        }
// @ts-ignore
      } else {
// @ts-ignore
        peg$currPos = s0;
// @ts-ignore
        s0 = peg$FAILED;
      }
// @ts-ignore
      if (s0 === peg$FAILED) {
// @ts-ignore
        s0 = peg$currPos;
// @ts-ignore
        if (input.charCodeAt(peg$currPos) === 39) {
// @ts-ignore
          s1 = peg$c9;
// @ts-ignore
          peg$currPos++;
// @ts-ignore
        } else {
// @ts-ignore
          s1 = peg$FAILED;
// @ts-ignore
          if (peg$silentFails === 0) { peg$fail(peg$e13); }
        }
// @ts-ignore
        if (s1 !== peg$FAILED) {
// @ts-ignore
          s2 = peg$currPos;
// @ts-ignore
          s3 = [];
// @ts-ignore
          s4 = input.charAt(peg$currPos);
// @ts-ignore
          if (peg$r4.test(s4)) {
// @ts-ignore
            peg$currPos++;
// @ts-ignore
          } else {
// @ts-ignore
            s4 = peg$FAILED;
// @ts-ignore
            if (peg$silentFails === 0) { peg$fail(peg$e14); }
          }
// @ts-ignore
          while (s4 !== peg$FAILED) {
// @ts-ignore
            s3.push(s4);
// @ts-ignore
            s4 = input.charAt(peg$currPos);
// @ts-ignore
            if (peg$r4.test(s4)) {
// @ts-ignore
              peg$currPos++;
// @ts-ignore
            } else {
// @ts-ignore
              s4 = peg$FAILED;
// @ts-ignore
              if (peg$silentFails === 0) { peg$fail(peg$e14); }
            }
          }
// @ts-ignore
          s2 = input.substring(s2, peg$currPos);
// @ts-ignore
          if (input.charCodeAt(peg$currPos) === 39) {
// @ts-ignore
            s3 = peg$c9;
// @ts-ignore
            peg$currPos++;
// @ts-ignore
          } else {
// @ts-ignore
            s3 = peg$FAILED;
// @ts-ignore
            if (peg$silentFails === 0) { peg$fail(peg$e13); }
          }
// @ts-ignore
          if (s3 !== peg$FAILED) {
// @ts-ignore
            peg$savedPos = s0;
// @ts-ignore
            s0 = peg$f12(s2);
// @ts-ignore
          } else {
// @ts-ignore
            peg$currPos = s0;
// @ts-ignore
            s0 = peg$FAILED;
          }
// @ts-ignore
        } else {
// @ts-ignore
          peg$currPos = s0;
// @ts-ignore
          s0 = peg$FAILED;
        }
// @ts-ignore
        if (s0 === peg$FAILED) {
// @ts-ignore
          s0 = peg$currPos;
// @ts-ignore
          if (input.charCodeAt(peg$currPos) === 39) {
// @ts-ignore
            s1 = peg$c9;
// @ts-ignore
            peg$currPos++;
// @ts-ignore
          } else {
// @ts-ignore
            s1 = peg$FAILED;
// @ts-ignore
            if (peg$silentFails === 0) { peg$fail(peg$e13); }
          }
// @ts-ignore
          if (s1 !== peg$FAILED) {
// @ts-ignore
            s2 = peg$currPos;
// @ts-ignore
            s3 = [];
// @ts-ignore
            s4 = input.charAt(peg$currPos);
// @ts-ignore
            if (peg$r4.test(s4)) {
// @ts-ignore
              peg$currPos++;
// @ts-ignore
            } else {
// @ts-ignore
              s4 = peg$FAILED;
// @ts-ignore
              if (peg$silentFails === 0) { peg$fail(peg$e14); }
            }
// @ts-ignore
            while (s4 !== peg$FAILED) {
// @ts-ignore
              s3.push(s4);
// @ts-ignore
              s4 = input.charAt(peg$currPos);
// @ts-ignore
              if (peg$r4.test(s4)) {
// @ts-ignore
                peg$currPos++;
// @ts-ignore
              } else {
// @ts-ignore
                s4 = peg$FAILED;
// @ts-ignore
                if (peg$silentFails === 0) { peg$fail(peg$e14); }
              }
            }
// @ts-ignore
            s2 = input.substring(s2, peg$currPos);
// @ts-ignore
            s3 = peg$currPos;
// @ts-ignore
            peg$silentFails++;
// @ts-ignore
            if (input.charCodeAt(peg$currPos) === 39) {
// @ts-ignore
              s4 = peg$c9;
// @ts-ignore
              peg$currPos++;
// @ts-ignore
            } else {
// @ts-ignore
              s4 = peg$FAILED;
// @ts-ignore
              if (peg$silentFails === 0) { peg$fail(peg$e13); }
            }
// @ts-ignore
            peg$silentFails--;
// @ts-ignore
            if (s4 === peg$FAILED) {
// @ts-ignore
              s3 = undefined;
// @ts-ignore
            } else {
// @ts-ignore
              peg$currPos = s3;
// @ts-ignore
              s3 = peg$FAILED;
            }
// @ts-ignore
            if (s3 !== peg$FAILED) {
// @ts-ignore
              peg$savedPos = s0;
// @ts-ignore
              s0 = peg$f13(s2);
// @ts-ignore
            } else {
// @ts-ignore
              peg$currPos = s0;
// @ts-ignore
              s0 = peg$FAILED;
            }
// @ts-ignore
          } else {
// @ts-ignore
            peg$currPos = s0;
// @ts-ignore
            s0 = peg$FAILED;
          }
        }
      }
    }

// @ts-ignore
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

// @ts-ignore
    return s0;
  }

// @ts-ignore
  function // @ts-ignore
peg$parseQuotedKeyValue() {
// @ts-ignore
    let s0, s1, s2, s3, s4, s5;

// @ts-ignore
    const key = peg$currPos * 41 + 12;
// @ts-ignore
    const cached = peg$resultsCache[key];

// @ts-ignore
    if (cached) {
// @ts-ignore
      peg$currPos = cached.nextPos;

// @ts-ignore
      return cached.result;
    }

// @ts-ignore
    s0 = peg$currPos;
// @ts-ignore
    s1 = peg$parseQuotedString();
// @ts-ignore
    if (s1 !== peg$FAILED) {
// @ts-ignore
      s2 = peg$parse_();
// @ts-ignore
      if (input.charCodeAt(peg$currPos) === 58) {
// @ts-ignore
        s3 = peg$c10;
// @ts-ignore
        peg$currPos++;
// @ts-ignore
      } else {
// @ts-ignore
        s3 = peg$FAILED;
// @ts-ignore
        if (peg$silentFails === 0) { peg$fail(peg$e15); }
      }
// @ts-ignore
      if (s3 !== peg$FAILED) {
// @ts-ignore
        s4 = peg$parse_();
// @ts-ignore
        s5 = peg$parseQuotedString();
// @ts-ignore
        if (s5 !== peg$FAILED) {
// @ts-ignore
          peg$savedPos = s0;
// @ts-ignore
          s0 = peg$f14(s1, s5);
// @ts-ignore
        } else {
// @ts-ignore
          peg$currPos = s0;
// @ts-ignore
          s0 = peg$FAILED;
        }
// @ts-ignore
      } else {
// @ts-ignore
        peg$currPos = s0;
// @ts-ignore
        s0 = peg$FAILED;
      }
// @ts-ignore
    } else {
// @ts-ignore
      peg$currPos = s0;
// @ts-ignore
      s0 = peg$FAILED;
    }

// @ts-ignore
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

// @ts-ignore
    return s0;
  }

// @ts-ignore
  function // @ts-ignore
peg$parseValue() {
// @ts-ignore
    let s0, s1;

// @ts-ignore
    const key = peg$currPos * 41 + 13;
// @ts-ignore
    const cached = peg$resultsCache[key];

// @ts-ignore
    if (cached) {
// @ts-ignore
      peg$currPos = cached.nextPos;

// @ts-ignore
      return cached.result;
    }

// @ts-ignore
    peg$silentFails++;
// @ts-ignore
    s0 = peg$parseQuotedKeyValue();
// @ts-ignore
    if (s0 === peg$FAILED) {
// @ts-ignore
      s0 = peg$parseFloat();
// @ts-ignore
      if (s0 === peg$FAILED) {
// @ts-ignore
        s0 = peg$parseInt();
// @ts-ignore
        if (s0 === peg$FAILED) {
// @ts-ignore
          s0 = peg$parseBool();
// @ts-ignore
          if (s0 === peg$FAILED) {
// @ts-ignore
            s0 = peg$parseRawString();
// @ts-ignore
            if (s0 === peg$FAILED) {
// @ts-ignore
              s0 = peg$parseQuotedString();
            }
          }
        }
      }
    }
// @ts-ignore
    peg$silentFails--;
// @ts-ignore
    if (s0 === peg$FAILED) {
// @ts-ignore
      s1 = peg$FAILED;
// @ts-ignore
      if (peg$silentFails === 0) { peg$fail(peg$e16); }
    }

// @ts-ignore
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

// @ts-ignore
    return s0;
  }

// @ts-ignore
  function // @ts-ignore
peg$parseValuesList() {
// @ts-ignore
    let s0, s1, s2, s3, s4, s5;

// @ts-ignore
    const key = peg$currPos * 41 + 14;
// @ts-ignore
    const cached = peg$resultsCache[key];

// @ts-ignore
    if (cached) {
// @ts-ignore
      peg$currPos = cached.nextPos;

// @ts-ignore
      return cached.result;
    }

// @ts-ignore
    peg$silentFails++;
// @ts-ignore
    s0 = peg$currPos;
// @ts-ignore
    s1 = peg$parseValue();
// @ts-ignore
    if (s1 !== peg$FAILED) {
// @ts-ignore
      s2 = peg$parse_();
// @ts-ignore
      if (input.charCodeAt(peg$currPos) === 44) {
// @ts-ignore
        s3 = peg$c11;
// @ts-ignore
        peg$currPos++;
// @ts-ignore
      } else {
// @ts-ignore
        s3 = peg$FAILED;
// @ts-ignore
        if (peg$silentFails === 0) { peg$fail(peg$e18); }
      }
// @ts-ignore
      if (s3 !== peg$FAILED) {
// @ts-ignore
        s4 = peg$parse_();
// @ts-ignore
        s5 = peg$parseValuesList();
// @ts-ignore
        if (s5 !== peg$FAILED) {
// @ts-ignore
          peg$savedPos = s0;
// @ts-ignore
          s0 = peg$f15(s1, s5);
// @ts-ignore
        } else {
// @ts-ignore
          peg$currPos = s0;
// @ts-ignore
          s0 = peg$FAILED;
        }
// @ts-ignore
      } else {
// @ts-ignore
        peg$currPos = s0;
// @ts-ignore
        s0 = peg$FAILED;
      }
// @ts-ignore
    } else {
// @ts-ignore
      peg$currPos = s0;
// @ts-ignore
      s0 = peg$FAILED;
    }
// @ts-ignore
    if (s0 === peg$FAILED) {
// @ts-ignore
      s0 = peg$currPos;
// @ts-ignore
      s1 = peg$parseValue();
// @ts-ignore
      if (s1 !== peg$FAILED) {
// @ts-ignore
        s2 = peg$parse_();
// @ts-ignore
        if (input.charCodeAt(peg$currPos) === 44) {
// @ts-ignore
          s3 = peg$c11;
// @ts-ignore
          peg$currPos++;
// @ts-ignore
        } else {
// @ts-ignore
          s3 = peg$FAILED;
// @ts-ignore
          if (peg$silentFails === 0) { peg$fail(peg$e18); }
        }
// @ts-ignore
        if (s3 !== peg$FAILED) {
// @ts-ignore
          peg$savedPos = s0;
// @ts-ignore
          s0 = peg$f16(s1, s3);
// @ts-ignore
        } else {
// @ts-ignore
          peg$currPos = s0;
// @ts-ignore
          s0 = peg$FAILED;
        }
// @ts-ignore
      } else {
// @ts-ignore
        peg$currPos = s0;
// @ts-ignore
        s0 = peg$FAILED;
      }
// @ts-ignore
      if (s0 === peg$FAILED) {
// @ts-ignore
        s0 = peg$currPos;
// @ts-ignore
        s1 = peg$parseValue();
// @ts-ignore
        if (s1 !== peg$FAILED) {
// @ts-ignore
          s2 = peg$parse_();
// @ts-ignore
          peg$savedPos = s0;
// @ts-ignore
          s0 = peg$f17(s1, s2);
// @ts-ignore
        } else {
// @ts-ignore
          peg$currPos = s0;
// @ts-ignore
          s0 = peg$FAILED;
        }
      }
    }
// @ts-ignore
    peg$silentFails--;
// @ts-ignore
    if (s0 === peg$FAILED) {
// @ts-ignore
      s1 = peg$FAILED;
// @ts-ignore
      if (peg$silentFails === 0) { peg$fail(peg$e17); }
    }

// @ts-ignore
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

// @ts-ignore
    return s0;
  }

// @ts-ignore
  function // @ts-ignore
peg$parseIdentifier() {
// @ts-ignore
    let s0, s1, s2, s3;

// @ts-ignore
    const key = peg$currPos * 41 + 15;
// @ts-ignore
    const cached = peg$resultsCache[key];

// @ts-ignore
    if (cached) {
// @ts-ignore
      peg$currPos = cached.nextPos;

// @ts-ignore
      return cached.result;
    }

// @ts-ignore
    s0 = peg$currPos;
// @ts-ignore
    s1 = peg$parseIdentifierSegment();
// @ts-ignore
    if (s1 !== peg$FAILED) {
// @ts-ignore
      if (input.charCodeAt(peg$currPos) === 46) {
// @ts-ignore
        s2 = peg$c12;
// @ts-ignore
        peg$currPos++;
// @ts-ignore
      } else {
// @ts-ignore
        s2 = peg$FAILED;
// @ts-ignore
        if (peg$silentFails === 0) { peg$fail(peg$e19); }
      }
// @ts-ignore
      if (s2 !== peg$FAILED) {
// @ts-ignore
        s3 = peg$parseIdentifier();
// @ts-ignore
        if (s3 !== peg$FAILED) {
// @ts-ignore
          peg$savedPos = s0;
// @ts-ignore
          s0 = peg$f18(s1, s3);
// @ts-ignore
        } else {
// @ts-ignore
          peg$currPos = s0;
// @ts-ignore
          s0 = peg$FAILED;
        }
// @ts-ignore
      } else {
// @ts-ignore
        peg$currPos = s0;
// @ts-ignore
        s0 = peg$FAILED;
      }
// @ts-ignore
    } else {
// @ts-ignore
      peg$currPos = s0;
// @ts-ignore
      s0 = peg$FAILED;
    }
// @ts-ignore
    if (s0 === peg$FAILED) {
// @ts-ignore
      s0 = peg$currPos;
// @ts-ignore
      s1 = peg$parseIdentifierSegment();
// @ts-ignore
      if (s1 !== peg$FAILED) {
// @ts-ignore
        peg$savedPos = s0;
// @ts-ignore
        s1 = peg$f19(s1);
      }
// @ts-ignore
      s0 = s1;
    }

// @ts-ignore
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

// @ts-ignore
    return s0;
  }

// @ts-ignore
  function // @ts-ignore
peg$parseIdentifierSegment() {
// @ts-ignore
    let s0, s1, s2, s3;

// @ts-ignore
    const key = peg$currPos * 41 + 16;
// @ts-ignore
    const cached = peg$resultsCache[key];

// @ts-ignore
    if (cached) {
// @ts-ignore
      peg$currPos = cached.nextPos;

// @ts-ignore
      return cached.result;
    }

// @ts-ignore
    s0 = peg$currPos;
// @ts-ignore
    s1 = [];
// @ts-ignore
    s2 = input.charAt(peg$currPos);
// @ts-ignore
    if (peg$r5.test(s2)) {
// @ts-ignore
      peg$currPos++;
// @ts-ignore
    } else {
// @ts-ignore
      s2 = peg$FAILED;
// @ts-ignore
      if (peg$silentFails === 0) { peg$fail(peg$e20); }
    }
// @ts-ignore
    if (s2 !== peg$FAILED) {
// @ts-ignore
      while (s2 !== peg$FAILED) {
// @ts-ignore
        s1.push(s2);
// @ts-ignore
        s2 = input.charAt(peg$currPos);
// @ts-ignore
        if (peg$r5.test(s2)) {
// @ts-ignore
          peg$currPos++;
// @ts-ignore
        } else {
// @ts-ignore
          s2 = peg$FAILED;
// @ts-ignore
          if (peg$silentFails === 0) { peg$fail(peg$e20); }
        }
      }
// @ts-ignore
    } else {
// @ts-ignore
      s1 = peg$FAILED;
    }
// @ts-ignore
    if (s1 !== peg$FAILED) {
// @ts-ignore
      peg$savedPos = s0;
// @ts-ignore
      s1 = peg$f20(s1);
    }
// @ts-ignore
    s0 = s1;
// @ts-ignore
    if (s0 === peg$FAILED) {
// @ts-ignore
      s0 = peg$currPos;
// @ts-ignore
      if (input.charCodeAt(peg$currPos) === 96) {
// @ts-ignore
        s1 = peg$c13;
// @ts-ignore
        peg$currPos++;
// @ts-ignore
      } else {
// @ts-ignore
        s1 = peg$FAILED;
// @ts-ignore
        if (peg$silentFails === 0) { peg$fail(peg$e21); }
      }
// @ts-ignore
      if (s1 !== peg$FAILED) {
// @ts-ignore
        s2 = peg$parseQuotedIdentifierSegmentBody();
// @ts-ignore
        if (input.charCodeAt(peg$currPos) === 96) {
// @ts-ignore
          s3 = peg$c13;
// @ts-ignore
          peg$currPos++;
// @ts-ignore
        } else {
// @ts-ignore
          s3 = peg$FAILED;
// @ts-ignore
          if (peg$silentFails === 0) { peg$fail(peg$e21); }
        }
// @ts-ignore
        if (s3 !== peg$FAILED) {
// @ts-ignore
          peg$savedPos = s0;
// @ts-ignore
          s0 = peg$f21(s2);
// @ts-ignore
        } else {
// @ts-ignore
          peg$currPos = s0;
// @ts-ignore
          s0 = peg$FAILED;
        }
// @ts-ignore
      } else {
// @ts-ignore
        peg$currPos = s0;
// @ts-ignore
        s0 = peg$FAILED;
      }
    }

// @ts-ignore
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

// @ts-ignore
    return s0;
  }

// @ts-ignore
  function // @ts-ignore
peg$parseQuotedIdentifierSegmentBody() {
// @ts-ignore
    let s0, s1, s2;

// @ts-ignore
    const key = peg$currPos * 41 + 17;
// @ts-ignore
    const cached = peg$resultsCache[key];

// @ts-ignore
    if (cached) {
// @ts-ignore
      peg$currPos = cached.nextPos;

// @ts-ignore
      return cached.result;
    }

// @ts-ignore
    s0 = peg$currPos;
// @ts-ignore
    s1 = [];
// @ts-ignore
    s2 = input.charAt(peg$currPos);
// @ts-ignore
    if (peg$r6.test(s2)) {
// @ts-ignore
      peg$currPos++;
// @ts-ignore
    } else {
// @ts-ignore
      s2 = peg$FAILED;
// @ts-ignore
      if (peg$silentFails === 0) { peg$fail(peg$e22); }
    }
// @ts-ignore
    while (s2 !== peg$FAILED) {
// @ts-ignore
      s1.push(s2);
// @ts-ignore
      s2 = input.charAt(peg$currPos);
// @ts-ignore
      if (peg$r6.test(s2)) {
// @ts-ignore
        peg$currPos++;
// @ts-ignore
      } else {
// @ts-ignore
        s2 = peg$FAILED;
// @ts-ignore
        if (peg$silentFails === 0) { peg$fail(peg$e22); }
      }
    }
// @ts-ignore
    peg$savedPos = s0;
// @ts-ignore
    s1 = peg$f22(s1);
// @ts-ignore
    s0 = s1;

// @ts-ignore
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

// @ts-ignore
    return s0;
  }

// @ts-ignore
  function // @ts-ignore
peg$parseExpression() {
// @ts-ignore
    let s0, s1, s2;

// @ts-ignore
    const key = peg$currPos * 41 + 18;
// @ts-ignore
    const cached = peg$resultsCache[key];

// @ts-ignore
    if (cached) {
// @ts-ignore
      peg$currPos = cached.nextPos;

// @ts-ignore
      return cached.result;
    }

// @ts-ignore
    s0 = peg$parseMaybeOrExpression();
// @ts-ignore
    if (s0 === peg$FAILED) {
// @ts-ignore
      s0 = peg$currPos;
// @ts-ignore
      s1 = peg$currPos;
// @ts-ignore
      peg$silentFails++;
// @ts-ignore
      s2 = input.substr(peg$currPos, 3);
// @ts-ignore
      if (s2.toLowerCase() === peg$c0) {
// @ts-ignore
        peg$currPos += (3);
// @ts-ignore
      } else {
// @ts-ignore
        s2 = peg$FAILED;
// @ts-ignore
        if (peg$silentFails === 0) { peg$fail(peg$e0); }
      }
// @ts-ignore
      if (s2 === peg$FAILED) {
// @ts-ignore
        s2 = input.substr(peg$currPos, 2);
// @ts-ignore
        if (s2.toLowerCase() === peg$c1) {
// @ts-ignore
          peg$currPos += (2);
// @ts-ignore
        } else {
// @ts-ignore
          s2 = peg$FAILED;
// @ts-ignore
          if (peg$silentFails === 0) { peg$fail(peg$e1); }
        }
      }
// @ts-ignore
      peg$silentFails--;
// @ts-ignore
      if (s2 !== peg$FAILED) {
// @ts-ignore
        peg$currPos = s1;
// @ts-ignore
        s1 = undefined;
// @ts-ignore
      } else {
// @ts-ignore
        s1 = peg$FAILED;
      }
// @ts-ignore
      if (s1 !== peg$FAILED) {
// @ts-ignore
        peg$savedPos = s0;
// @ts-ignore
        s1 = peg$f23();
      }
// @ts-ignore
      s0 = s1;
    }

// @ts-ignore
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

// @ts-ignore
    return s0;
  }

// @ts-ignore
  function // @ts-ignore
peg$parseParenthesizedExpression() {
// @ts-ignore
    let s0, s1, s2, s3, s4, s5;

// @ts-ignore
    const key = peg$currPos * 41 + 19;
// @ts-ignore
    const cached = peg$resultsCache[key];

// @ts-ignore
    if (cached) {
// @ts-ignore
      peg$currPos = cached.nextPos;

// @ts-ignore
      return cached.result;
    }

// @ts-ignore
    s0 = peg$currPos;
// @ts-ignore
    if (input.charCodeAt(peg$currPos) === 40) {
// @ts-ignore
      s1 = peg$c14;
// @ts-ignore
      peg$currPos++;
// @ts-ignore
    } else {
// @ts-ignore
      s1 = peg$FAILED;
// @ts-ignore
      if (peg$silentFails === 0) { peg$fail(peg$e23); }
    }
// @ts-ignore
    if (s1 !== peg$FAILED) {
// @ts-ignore
      s2 = peg$parse_();
// @ts-ignore
      s3 = peg$parseExpression();
// @ts-ignore
      if (s3 !== peg$FAILED) {
// @ts-ignore
        s4 = peg$parse_();
// @ts-ignore
        if (input.charCodeAt(peg$currPos) === 41) {
// @ts-ignore
          s5 = peg$c15;
// @ts-ignore
          peg$currPos++;
// @ts-ignore
        } else {
// @ts-ignore
          s5 = peg$FAILED;
// @ts-ignore
          if (peg$silentFails === 0) { peg$fail(peg$e24); }
        }
// @ts-ignore
        if (s5 === peg$FAILED) {
// @ts-ignore
          s5 = null;
        }
// @ts-ignore
        peg$savedPos = s0;
// @ts-ignore
        s0 = peg$f24(s3, s5);
// @ts-ignore
      } else {
// @ts-ignore
        peg$currPos = s0;
// @ts-ignore
        s0 = peg$FAILED;
      }
// @ts-ignore
    } else {
// @ts-ignore
      peg$currPos = s0;
// @ts-ignore
      s0 = peg$FAILED;
    }

// @ts-ignore
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

// @ts-ignore
    return s0;
  }

// @ts-ignore
  function // @ts-ignore
peg$parseSearchExpression() {
// @ts-ignore
    let s0, s1, s2, s3;

// @ts-ignore
    const key = peg$currPos * 41 + 20;
// @ts-ignore
    const cached = peg$resultsCache[key];

// @ts-ignore
    if (cached) {
// @ts-ignore
      peg$currPos = cached.nextPos;

// @ts-ignore
      return cached.result;
    }

// @ts-ignore
    s0 = peg$currPos;
// @ts-ignore
    s1 = peg$parseRawString();
// @ts-ignore
    if (s1 === peg$FAILED) {
// @ts-ignore
      s1 = peg$parseQuotedString();
// @ts-ignore
      if (s1 === peg$FAILED) {
// @ts-ignore
        s1 = peg$parseFloat();
// @ts-ignore
        if (s1 === peg$FAILED) {
// @ts-ignore
          s1 = peg$parseInt();
// @ts-ignore
          if (s1 === peg$FAILED) {
// @ts-ignore
            s1 = peg$parseBool();
          }
        }
      }
    }
// @ts-ignore
    if (s1 !== peg$FAILED) {
// @ts-ignore
      s2 = peg$currPos;
// @ts-ignore
      peg$silentFails++;
// @ts-ignore
      s3 = input.substr(peg$currPos, 3);
// @ts-ignore
      if (s3.toLowerCase() === peg$c2) {
// @ts-ignore
        peg$currPos += (3);
// @ts-ignore
      } else {
// @ts-ignore
        s3 = peg$FAILED;
// @ts-ignore
        if (peg$silentFails === 0) { peg$fail(peg$e2); }
      }
// @ts-ignore
      if (s3 === peg$FAILED) {
// @ts-ignore
        s3 = input.substr(peg$currPos, 2);
// @ts-ignore
        if (s3.toLowerCase() === peg$c5) {
// @ts-ignore
          peg$currPos += (2);
// @ts-ignore
        } else {
// @ts-ignore
          s3 = peg$FAILED;
// @ts-ignore
          if (peg$silentFails === 0) { peg$fail(peg$e5); }
        }
// @ts-ignore
        if (s3 === peg$FAILED) {
// @ts-ignore
          s3 = input.substr(peg$currPos, 2);
// @ts-ignore
          if (s3.toLowerCase() === peg$c7) {
// @ts-ignore
            peg$currPos += (2);
// @ts-ignore
          } else {
// @ts-ignore
            s3 = peg$FAILED;
// @ts-ignore
            if (peg$silentFails === 0) { peg$fail(peg$e7); }
          }
// @ts-ignore
          if (s3 === peg$FAILED) {
// @ts-ignore
            s3 = input.substr(peg$currPos, 8);
// @ts-ignore
            if (s3.toLowerCase() === peg$c3) {
// @ts-ignore
              peg$currPos += (8);
// @ts-ignore
            } else {
// @ts-ignore
              s3 = peg$FAILED;
// @ts-ignore
              if (peg$silentFails === 0) { peg$fail(peg$e3); }
            }
          }
        }
      }
// @ts-ignore
      peg$silentFails--;
// @ts-ignore
      if (s3 === peg$FAILED) {
// @ts-ignore
        s2 = undefined;
// @ts-ignore
      } else {
// @ts-ignore
        peg$currPos = s2;
// @ts-ignore
        s2 = peg$FAILED;
      }
// @ts-ignore
      if (s2 !== peg$FAILED) {
// @ts-ignore
        peg$savedPos = s0;
// @ts-ignore
        s0 = peg$f25(s1);
// @ts-ignore
      } else {
// @ts-ignore
        peg$currPos = s0;
// @ts-ignore
        s0 = peg$FAILED;
      }
// @ts-ignore
    } else {
// @ts-ignore
      peg$currPos = s0;
// @ts-ignore
      s0 = peg$FAILED;
    }

// @ts-ignore
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

// @ts-ignore
    return s0;
  }

// @ts-ignore
  function // @ts-ignore
peg$parseComparisonExpression() {
// @ts-ignore
    let s0, s1, s2, s3, s4, s5, s6;

// @ts-ignore
    const key = peg$currPos * 41 + 21;
// @ts-ignore
    const cached = peg$resultsCache[key];

// @ts-ignore
    if (cached) {
// @ts-ignore
      peg$currPos = cached.nextPos;

// @ts-ignore
      return cached.result;
    }

// @ts-ignore
    s0 = peg$currPos;
// @ts-ignore
    s1 = peg$parseIdentifier();
// @ts-ignore
    if (s1 !== peg$FAILED) {
// @ts-ignore
      s2 = peg$parse_();
// @ts-ignore
      s3 = peg$parseComparisonOperator();
// @ts-ignore
      if (s3 !== peg$FAILED) {
// @ts-ignore
        s4 = peg$parse_();
// @ts-ignore
        s5 = peg$parseValue();
// @ts-ignore
        if (s5 === peg$FAILED) {
// @ts-ignore
          s5 = null;
        }
// @ts-ignore
        s6 = peg$parse_();
// @ts-ignore
        peg$savedPos = s0;
// @ts-ignore
        s0 = peg$f26(s1, s3, s5, s6);
// @ts-ignore
      } else {
// @ts-ignore
        peg$currPos = s0;
// @ts-ignore
        s0 = peg$FAILED;
      }
// @ts-ignore
    } else {
// @ts-ignore
      peg$currPos = s0;
// @ts-ignore
      s0 = peg$FAILED;
    }

// @ts-ignore
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

// @ts-ignore
    return s0;
  }

// @ts-ignore
  function // @ts-ignore
peg$parseComparisonOperator() {
// @ts-ignore
    let s0, s1;

// @ts-ignore
    const key = peg$currPos * 41 + 22;
// @ts-ignore
    const cached = peg$resultsCache[key];

// @ts-ignore
    if (cached) {
// @ts-ignore
      peg$currPos = cached.nextPos;

// @ts-ignore
      return cached.result;
    }

// @ts-ignore
    s0 = peg$currPos;
// @ts-ignore
    if (input.substr(peg$currPos, 2) === peg$c16) {
// @ts-ignore
      s1 = peg$c16;
// @ts-ignore
      peg$currPos += 2;
// @ts-ignore
    } else {
// @ts-ignore
      s1 = peg$FAILED;
// @ts-ignore
      if (peg$silentFails === 0) { peg$fail(peg$e25); }
    }
// @ts-ignore
    if (s1 === peg$FAILED) {
// @ts-ignore
      if (input.charCodeAt(peg$currPos) === 61) {
// @ts-ignore
        s1 = peg$c17;
// @ts-ignore
        peg$currPos++;
// @ts-ignore
      } else {
// @ts-ignore
        s1 = peg$FAILED;
// @ts-ignore
        if (peg$silentFails === 0) { peg$fail(peg$e26); }
      }
// @ts-ignore
      if (s1 === peg$FAILED) {
// @ts-ignore
        if (input.substr(peg$currPos, 2) === peg$c18) {
// @ts-ignore
          s1 = peg$c18;
// @ts-ignore
          peg$currPos += 2;
// @ts-ignore
        } else {
// @ts-ignore
          s1 = peg$FAILED;
// @ts-ignore
          if (peg$silentFails === 0) { peg$fail(peg$e27); }
        }
// @ts-ignore
        if (s1 === peg$FAILED) {
// @ts-ignore
          if (input.substr(peg$currPos, 2) === peg$c19) {
// @ts-ignore
            s1 = peg$c19;
// @ts-ignore
            peg$currPos += 2;
// @ts-ignore
          } else {
// @ts-ignore
            s1 = peg$FAILED;
// @ts-ignore
            if (peg$silentFails === 0) { peg$fail(peg$e28); }
          }
// @ts-ignore
          if (s1 === peg$FAILED) {
// @ts-ignore
            if (input.substr(peg$currPos, 2) === peg$c20) {
// @ts-ignore
              s1 = peg$c20;
// @ts-ignore
              peg$currPos += 2;
// @ts-ignore
            } else {
// @ts-ignore
              s1 = peg$FAILED;
// @ts-ignore
              if (peg$silentFails === 0) { peg$fail(peg$e29); }
            }
// @ts-ignore
            if (s1 === peg$FAILED) {
// @ts-ignore
              if (input.charCodeAt(peg$currPos) === 60) {
// @ts-ignore
                s1 = peg$c21;
// @ts-ignore
                peg$currPos++;
// @ts-ignore
              } else {
// @ts-ignore
                s1 = peg$FAILED;
// @ts-ignore
                if (peg$silentFails === 0) { peg$fail(peg$e30); }
              }
// @ts-ignore
              if (s1 === peg$FAILED) {
// @ts-ignore
                if (input.substr(peg$currPos, 2) === peg$c22) {
// @ts-ignore
                  s1 = peg$c22;
// @ts-ignore
                  peg$currPos += 2;
// @ts-ignore
                } else {
// @ts-ignore
                  s1 = peg$FAILED;
// @ts-ignore
                  if (peg$silentFails === 0) { peg$fail(peg$e31); }
                }
// @ts-ignore
                if (s1 === peg$FAILED) {
// @ts-ignore
                  if (input.charCodeAt(peg$currPos) === 62) {
// @ts-ignore
                    s1 = peg$c23;
// @ts-ignore
                    peg$currPos++;
// @ts-ignore
                  } else {
// @ts-ignore
                    s1 = peg$FAILED;
// @ts-ignore
                    if (peg$silentFails === 0) { peg$fail(peg$e32); }
                  }
                }
              }
            }
          }
        }
      }
    }
// @ts-ignore
    if (s1 !== peg$FAILED) {
// @ts-ignore
      peg$savedPos = s0;
// @ts-ignore
      s1 = peg$f27(s1);
    }
// @ts-ignore
    s0 = s1;

// @ts-ignore
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

// @ts-ignore
    return s0;
  }

// @ts-ignore
  function // @ts-ignore
peg$parsePossibleComparisonExpression() {
// @ts-ignore
    let s0, s1, s2, s3, s4, s5;

// @ts-ignore
    const key = peg$currPos * 41 + 23;
// @ts-ignore
    const cached = peg$resultsCache[key];

// @ts-ignore
    if (cached) {
// @ts-ignore
      peg$currPos = cached.nextPos;

// @ts-ignore
      return cached.result;
    }

// @ts-ignore
    s0 = peg$currPos;
// @ts-ignore
    s1 = peg$parseIdentifier();
// @ts-ignore
    if (s1 !== peg$FAILED) {
// @ts-ignore
      s2 = peg$parse_();
// @ts-ignore
      s3 = peg$currPos;
// @ts-ignore
      s4 = [];
// @ts-ignore
      s5 = input.charAt(peg$currPos);
// @ts-ignore
      if (peg$r7.test(s5)) {
// @ts-ignore
        peg$currPos++;
// @ts-ignore
      } else {
// @ts-ignore
        s5 = peg$FAILED;
// @ts-ignore
        if (peg$silentFails === 0) { peg$fail(peg$e33); }
      }
// @ts-ignore
      while (s5 !== peg$FAILED) {
// @ts-ignore
        s4.push(s5);
// @ts-ignore
        s5 = input.charAt(peg$currPos);
// @ts-ignore
        if (peg$r7.test(s5)) {
// @ts-ignore
          peg$currPos++;
// @ts-ignore
        } else {
// @ts-ignore
          s5 = peg$FAILED;
// @ts-ignore
          if (peg$silentFails === 0) { peg$fail(peg$e33); }
        }
      }
// @ts-ignore
      s3 = input.substring(s3, peg$currPos);
// @ts-ignore
      s4 = peg$parse_();
// @ts-ignore
      peg$savedPos = s0;
// @ts-ignore
      s0 = peg$f28(s1, s2, s3, s4);
// @ts-ignore
    } else {
// @ts-ignore
      peg$currPos = s0;
// @ts-ignore
      s0 = peg$FAILED;
    }

// @ts-ignore
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

// @ts-ignore
    return s0;
  }

// @ts-ignore
  function // @ts-ignore
peg$parseIsExpression() {
// @ts-ignore
    let s0, s1, s2, s3, s4, s5, s6, s7;

// @ts-ignore
    const key = peg$currPos * 41 + 24;
// @ts-ignore
    const cached = peg$resultsCache[key];

// @ts-ignore
    if (cached) {
// @ts-ignore
      peg$currPos = cached.nextPos;

// @ts-ignore
      return cached.result;
    }

// @ts-ignore
    s0 = peg$currPos;
// @ts-ignore
    s1 = peg$parseIdentifier();
// @ts-ignore
    if (s1 !== peg$FAILED) {
// @ts-ignore
      s2 = peg$parse__();
// @ts-ignore
      if (s2 !== peg$FAILED) {
// @ts-ignore
        s3 = peg$parseKeywordIs();
// @ts-ignore
        if (s3 !== peg$FAILED) {
// @ts-ignore
          s4 = peg$parse__();
// @ts-ignore
          if (s4 !== peg$FAILED) {
// @ts-ignore
            s5 = peg$parseKeywordEmpty();
// @ts-ignore
            if (s5 !== peg$FAILED) {
// @ts-ignore
              peg$savedPos = s0;
// @ts-ignore
              s0 = peg$f29(s1, s3, s5);
// @ts-ignore
            } else {
// @ts-ignore
              peg$currPos = s0;
// @ts-ignore
              s0 = peg$FAILED;
            }
// @ts-ignore
          } else {
// @ts-ignore
            peg$currPos = s0;
// @ts-ignore
            s0 = peg$FAILED;
          }
// @ts-ignore
        } else {
// @ts-ignore
          peg$currPos = s0;
// @ts-ignore
          s0 = peg$FAILED;
        }
// @ts-ignore
      } else {
// @ts-ignore
        peg$currPos = s0;
// @ts-ignore
        s0 = peg$FAILED;
      }
// @ts-ignore
    } else {
// @ts-ignore
      peg$currPos = s0;
// @ts-ignore
      s0 = peg$FAILED;
    }
// @ts-ignore
    if (s0 === peg$FAILED) {
// @ts-ignore
      s0 = peg$currPos;
// @ts-ignore
      s1 = peg$parseIdentifier();
// @ts-ignore
      if (s1 !== peg$FAILED) {
// @ts-ignore
        s2 = peg$parse__();
// @ts-ignore
        if (s2 !== peg$FAILED) {
// @ts-ignore
          s3 = peg$parseKeywordIs();
// @ts-ignore
          if (s3 !== peg$FAILED) {
// @ts-ignore
            s4 = peg$parse__();
// @ts-ignore
            if (s4 !== peg$FAILED) {
// @ts-ignore
              s5 = peg$parseKeywordNull();
// @ts-ignore
              if (s5 !== peg$FAILED) {
// @ts-ignore
                peg$savedPos = s0;
// @ts-ignore
                s0 = peg$f30(s1, s3, s5);
// @ts-ignore
              } else {
// @ts-ignore
                peg$currPos = s0;
// @ts-ignore
                s0 = peg$FAILED;
              }
// @ts-ignore
            } else {
// @ts-ignore
              peg$currPos = s0;
// @ts-ignore
              s0 = peg$FAILED;
            }
// @ts-ignore
          } else {
// @ts-ignore
            peg$currPos = s0;
// @ts-ignore
            s0 = peg$FAILED;
          }
// @ts-ignore
        } else {
// @ts-ignore
          peg$currPos = s0;
// @ts-ignore
          s0 = peg$FAILED;
        }
// @ts-ignore
      } else {
// @ts-ignore
        peg$currPos = s0;
// @ts-ignore
        s0 = peg$FAILED;
      }
// @ts-ignore
      if (s0 === peg$FAILED) {
// @ts-ignore
        s0 = peg$currPos;
// @ts-ignore
        s1 = peg$parseIdentifier();
// @ts-ignore
        if (s1 !== peg$FAILED) {
// @ts-ignore
          s2 = peg$parse__();
// @ts-ignore
          if (s2 !== peg$FAILED) {
// @ts-ignore
            s3 = peg$parseKeywordIs();
// @ts-ignore
            if (s3 !== peg$FAILED) {
// @ts-ignore
              s4 = peg$parse__();
// @ts-ignore
              if (s4 !== peg$FAILED) {
// @ts-ignore
                s5 = peg$parseKeywordNot();
// @ts-ignore
                if (s5 !== peg$FAILED) {
// @ts-ignore
                  s6 = peg$parse__();
// @ts-ignore
                  if (s6 !== peg$FAILED) {
// @ts-ignore
                    s7 = peg$parseKeywordNull();
// @ts-ignore
                    if (s7 !== peg$FAILED) {
// @ts-ignore
                      peg$savedPos = s0;
// @ts-ignore
                      s0 = peg$f31(s1, s3, s5, s7);
// @ts-ignore
                    } else {
// @ts-ignore
                      peg$currPos = s0;
// @ts-ignore
                      s0 = peg$FAILED;
                    }
// @ts-ignore
                  } else {
// @ts-ignore
                    peg$currPos = s0;
// @ts-ignore
                    s0 = peg$FAILED;
                  }
// @ts-ignore
                } else {
// @ts-ignore
                  peg$currPos = s0;
// @ts-ignore
                  s0 = peg$FAILED;
                }
// @ts-ignore
              } else {
// @ts-ignore
                peg$currPos = s0;
// @ts-ignore
                s0 = peg$FAILED;
              }
// @ts-ignore
            } else {
// @ts-ignore
              peg$currPos = s0;
// @ts-ignore
              s0 = peg$FAILED;
            }
// @ts-ignore
          } else {
// @ts-ignore
            peg$currPos = s0;
// @ts-ignore
            s0 = peg$FAILED;
          }
// @ts-ignore
        } else {
// @ts-ignore
          peg$currPos = s0;
// @ts-ignore
          s0 = peg$FAILED;
        }
// @ts-ignore
        if (s0 === peg$FAILED) {
// @ts-ignore
          s0 = peg$currPos;
// @ts-ignore
          s1 = peg$parseIdentifier();
// @ts-ignore
          if (s1 !== peg$FAILED) {
// @ts-ignore
            s2 = peg$parse__();
// @ts-ignore
            if (s2 !== peg$FAILED) {
// @ts-ignore
              s3 = peg$parseKeywordIs();
// @ts-ignore
              if (s3 !== peg$FAILED) {
// @ts-ignore
                s4 = peg$parse__();
// @ts-ignore
                if (s4 !== peg$FAILED) {
// @ts-ignore
                  s5 = peg$parseKeywordNot();
// @ts-ignore
                  if (s5 !== peg$FAILED) {
// @ts-ignore
                    s6 = peg$parse__();
// @ts-ignore
                    if (s6 !== peg$FAILED) {
// @ts-ignore
                      s7 = peg$parseKeywordEmpty();
// @ts-ignore
                      if (s7 !== peg$FAILED) {
// @ts-ignore
                        peg$savedPos = s0;
// @ts-ignore
                        s0 = peg$f32(s1, s3, s5, s7);
// @ts-ignore
                      } else {
// @ts-ignore
                        peg$currPos = s0;
// @ts-ignore
                        s0 = peg$FAILED;
                      }
// @ts-ignore
                    } else {
// @ts-ignore
                      peg$currPos = s0;
// @ts-ignore
                      s0 = peg$FAILED;
                    }
// @ts-ignore
                  } else {
// @ts-ignore
                    peg$currPos = s0;
// @ts-ignore
                    s0 = peg$FAILED;
                  }
// @ts-ignore
                } else {
// @ts-ignore
                  peg$currPos = s0;
// @ts-ignore
                  s0 = peg$FAILED;
                }
// @ts-ignore
              } else {
// @ts-ignore
                peg$currPos = s0;
// @ts-ignore
                s0 = peg$FAILED;
              }
// @ts-ignore
            } else {
// @ts-ignore
              peg$currPos = s0;
// @ts-ignore
              s0 = peg$FAILED;
            }
// @ts-ignore
          } else {
// @ts-ignore
            peg$currPos = s0;
// @ts-ignore
            s0 = peg$FAILED;
          }
        }
      }
    }

// @ts-ignore
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

// @ts-ignore
    return s0;
  }

// @ts-ignore
  function // @ts-ignore
peg$parseInExpression() {
// @ts-ignore
    let s0, s1, s2, s3, s4, s5, s6, s7, s8, s9;

// @ts-ignore
    const key = peg$currPos * 41 + 25;
// @ts-ignore
    const cached = peg$resultsCache[key];

// @ts-ignore
    if (cached) {
// @ts-ignore
      peg$currPos = cached.nextPos;

// @ts-ignore
      return cached.result;
    }

// @ts-ignore
    s0 = peg$currPos;
// @ts-ignore
    s1 = peg$parseIdentifier();
// @ts-ignore
    if (s1 !== peg$FAILED) {
// @ts-ignore
      s2 = peg$parse__();
// @ts-ignore
      if (s2 !== peg$FAILED) {
// @ts-ignore
        s3 = peg$parseKeywordIn();
// @ts-ignore
        if (s3 !== peg$FAILED) {
// @ts-ignore
          s4 = peg$parse__();
// @ts-ignore
          if (s4 !== peg$FAILED) {
// @ts-ignore
            if (input.charCodeAt(peg$currPos) === 40) {
// @ts-ignore
              s5 = peg$c14;
// @ts-ignore
              peg$currPos++;
// @ts-ignore
            } else {
// @ts-ignore
              s5 = peg$FAILED;
// @ts-ignore
              if (peg$silentFails === 0) { peg$fail(peg$e23); }
            }
// @ts-ignore
            if (s5 !== peg$FAILED) {
// @ts-ignore
              s6 = peg$parse_();
// @ts-ignore
              s7 = peg$parseValuesList();
// @ts-ignore
              if (s7 === peg$FAILED) {
// @ts-ignore
                s7 = null;
              }
// @ts-ignore
              s8 = peg$parse_();
// @ts-ignore
              if (input.charCodeAt(peg$currPos) === 41) {
// @ts-ignore
                s9 = peg$c15;
// @ts-ignore
                peg$currPos++;
// @ts-ignore
              } else {
// @ts-ignore
                s9 = peg$FAILED;
// @ts-ignore
                if (peg$silentFails === 0) { peg$fail(peg$e24); }
              }
// @ts-ignore
              if (s9 === peg$FAILED) {
// @ts-ignore
                s9 = null;
              }
// @ts-ignore
              peg$savedPos = s0;
// @ts-ignore
              s0 = peg$f33(s1, s3, s7, s9);
// @ts-ignore
            } else {
// @ts-ignore
              peg$currPos = s0;
// @ts-ignore
              s0 = peg$FAILED;
            }
// @ts-ignore
          } else {
// @ts-ignore
            peg$currPos = s0;
// @ts-ignore
            s0 = peg$FAILED;
          }
// @ts-ignore
        } else {
// @ts-ignore
          peg$currPos = s0;
// @ts-ignore
          s0 = peg$FAILED;
        }
// @ts-ignore
      } else {
// @ts-ignore
        peg$currPos = s0;
// @ts-ignore
        s0 = peg$FAILED;
      }
// @ts-ignore
    } else {
// @ts-ignore
      peg$currPos = s0;
// @ts-ignore
      s0 = peg$FAILED;
    }

// @ts-ignore
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

// @ts-ignore
    return s0;
  }

// @ts-ignore
  function // @ts-ignore
peg$parseNotInExpression() {
// @ts-ignore
    let s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11;

// @ts-ignore
    const key = peg$currPos * 41 + 26;
// @ts-ignore
    const cached = peg$resultsCache[key];

// @ts-ignore
    if (cached) {
// @ts-ignore
      peg$currPos = cached.nextPos;

// @ts-ignore
      return cached.result;
    }

// @ts-ignore
    s0 = peg$currPos;
// @ts-ignore
    s1 = peg$parseIdentifier();
// @ts-ignore
    if (s1 !== peg$FAILED) {
// @ts-ignore
      s2 = peg$parse__();
// @ts-ignore
      if (s2 !== peg$FAILED) {
// @ts-ignore
        s3 = peg$parseKeywordNot();
// @ts-ignore
        if (s3 !== peg$FAILED) {
// @ts-ignore
          s4 = peg$parse_();
// @ts-ignore
          s5 = peg$parseKeywordIn();
// @ts-ignore
          if (s5 !== peg$FAILED) {
// @ts-ignore
            s6 = peg$parse_();
// @ts-ignore
            if (input.charCodeAt(peg$currPos) === 40) {
// @ts-ignore
              s7 = peg$c14;
// @ts-ignore
              peg$currPos++;
// @ts-ignore
            } else {
// @ts-ignore
              s7 = peg$FAILED;
// @ts-ignore
              if (peg$silentFails === 0) { peg$fail(peg$e23); }
            }
// @ts-ignore
            if (s7 !== peg$FAILED) {
// @ts-ignore
              s8 = peg$parse_();
// @ts-ignore
              s9 = peg$parseValuesList();
// @ts-ignore
              if (s9 === peg$FAILED) {
// @ts-ignore
                s9 = null;
              }
// @ts-ignore
              s10 = peg$parse_();
// @ts-ignore
              if (input.charCodeAt(peg$currPos) === 41) {
// @ts-ignore
                s11 = peg$c15;
// @ts-ignore
                peg$currPos++;
// @ts-ignore
              } else {
// @ts-ignore
                s11 = peg$FAILED;
// @ts-ignore
                if (peg$silentFails === 0) { peg$fail(peg$e24); }
              }
// @ts-ignore
              if (s11 === peg$FAILED) {
// @ts-ignore
                s11 = null;
              }
// @ts-ignore
              peg$savedPos = s0;
// @ts-ignore
              s0 = peg$f34(s1, s3, s5, s9, s11);
// @ts-ignore
            } else {
// @ts-ignore
              peg$currPos = s0;
// @ts-ignore
              s0 = peg$FAILED;
            }
// @ts-ignore
          } else {
// @ts-ignore
            peg$currPos = s0;
// @ts-ignore
            s0 = peg$FAILED;
          }
// @ts-ignore
        } else {
// @ts-ignore
          peg$currPos = s0;
// @ts-ignore
          s0 = peg$FAILED;
        }
// @ts-ignore
      } else {
// @ts-ignore
        peg$currPos = s0;
// @ts-ignore
        s0 = peg$FAILED;
      }
// @ts-ignore
    } else {
// @ts-ignore
      peg$currPos = s0;
// @ts-ignore
      s0 = peg$FAILED;
    }

// @ts-ignore
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

// @ts-ignore
    return s0;
  }

// @ts-ignore
  function // @ts-ignore
peg$parseContainsExpression() {
// @ts-ignore
    let s0, s1, s2, s3, s4, s5, s6;

// @ts-ignore
    const key = peg$currPos * 41 + 27;
// @ts-ignore
    const cached = peg$resultsCache[key];

// @ts-ignore
    if (cached) {
// @ts-ignore
      peg$currPos = cached.nextPos;

// @ts-ignore
      return cached.result;
    }

// @ts-ignore
    s0 = peg$currPos;
// @ts-ignore
    s1 = peg$parseIdentifier();
// @ts-ignore
    if (s1 !== peg$FAILED) {
// @ts-ignore
      s2 = peg$parse__();
// @ts-ignore
      if (s2 !== peg$FAILED) {
// @ts-ignore
        s3 = peg$parseKeywordContains();
// @ts-ignore
        if (s3 !== peg$FAILED) {
// @ts-ignore
          s4 = peg$parse__();
// @ts-ignore
          if (s4 === peg$FAILED) {
// @ts-ignore
            s4 = null;
          }
// @ts-ignore
          s5 = peg$parseValue();
// @ts-ignore
          if (s5 === peg$FAILED) {
// @ts-ignore
            s5 = null;
          }
// @ts-ignore
          s6 = peg$parse_();
// @ts-ignore
          peg$savedPos = s0;
// @ts-ignore
          s0 = peg$f35(s1, s3, s5, s6);
// @ts-ignore
        } else {
// @ts-ignore
          peg$currPos = s0;
// @ts-ignore
          s0 = peg$FAILED;
        }
// @ts-ignore
      } else {
// @ts-ignore
        peg$currPos = s0;
// @ts-ignore
        s0 = peg$FAILED;
      }
// @ts-ignore
    } else {
// @ts-ignore
      peg$currPos = s0;
// @ts-ignore
      s0 = peg$FAILED;
    }

// @ts-ignore
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

// @ts-ignore
    return s0;
  }

// @ts-ignore
  function // @ts-ignore
peg$parseBaseExpression() {
// @ts-ignore
    let s0;

// @ts-ignore
    const key = peg$currPos * 41 + 28;
// @ts-ignore
    const cached = peg$resultsCache[key];

// @ts-ignore
    if (cached) {
// @ts-ignore
      peg$currPos = cached.nextPos;

// @ts-ignore
      return cached.result;
    }

// @ts-ignore
    s0 = peg$parseParenthesizedExpression();
// @ts-ignore
    if (s0 === peg$FAILED) {
// @ts-ignore
      s0 = peg$parseInExpression();
// @ts-ignore
      if (s0 === peg$FAILED) {
// @ts-ignore
        s0 = peg$parseNotInExpression();
// @ts-ignore
        if (s0 === peg$FAILED) {
// @ts-ignore
          s0 = peg$parseNotExpression();
// @ts-ignore
          if (s0 === peg$FAILED) {
// @ts-ignore
            s0 = peg$parseComparisonExpression();
// @ts-ignore
            if (s0 === peg$FAILED) {
// @ts-ignore
              s0 = peg$parseIsExpression();
// @ts-ignore
              if (s0 === peg$FAILED) {
// @ts-ignore
                s0 = peg$parseContainsExpression();
// @ts-ignore
                if (s0 === peg$FAILED) {
// @ts-ignore
                  s0 = peg$parseQuotedKeyValue();
// @ts-ignore
                  if (s0 === peg$FAILED) {
// @ts-ignore
                    s0 = peg$parsePossibleComparisonExpression();
// @ts-ignore
                    if (s0 === peg$FAILED) {
// @ts-ignore
                      s0 = peg$parseSearchExpression();
                    }
                  }
                }
              }
            }
          }
        }
      }
    }

// @ts-ignore
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

// @ts-ignore
    return s0;
  }

// @ts-ignore
  function // @ts-ignore
peg$parseMaybeAndExpression() {
// @ts-ignore
    let s0;

// @ts-ignore
    const key = peg$currPos * 41 + 29;
// @ts-ignore
    const cached = peg$resultsCache[key];

// @ts-ignore
    if (cached) {
// @ts-ignore
      peg$currPos = cached.nextPos;

// @ts-ignore
      return cached.result;
    }

// @ts-ignore
    s0 = peg$parseAndExpression();
// @ts-ignore
    if (s0 === peg$FAILED) {
// @ts-ignore
      s0 = peg$parseImplicitAndExpression();
// @ts-ignore
      if (s0 === peg$FAILED) {
// @ts-ignore
        s0 = peg$parseBaseExpression();
      }
    }

// @ts-ignore
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

// @ts-ignore
    return s0;
  }

// @ts-ignore
  function // @ts-ignore
peg$parseAndExpression() {
// @ts-ignore
    let s0, s1, s2, s3, s4, s5, s6;

// @ts-ignore
    const key = peg$currPos * 41 + 30;
// @ts-ignore
    const cached = peg$resultsCache[key];

// @ts-ignore
    if (cached) {
// @ts-ignore
      peg$currPos = cached.nextPos;

// @ts-ignore
      return cached.result;
    }

// @ts-ignore
    s0 = peg$currPos;
// @ts-ignore
    s1 = peg$parseBaseExpression();
// @ts-ignore
    if (s1 !== peg$FAILED) {
// @ts-ignore
      s2 = peg$parse__();
// @ts-ignore
      if (s2 !== peg$FAILED) {
// @ts-ignore
        s3 = peg$parseKeywordAnd();
// @ts-ignore
        if (s3 !== peg$FAILED) {
// @ts-ignore
          s4 = peg$parse__();
// @ts-ignore
          if (s4 !== peg$FAILED) {
// @ts-ignore
            s5 = peg$parseMaybeAndExpression();
// @ts-ignore
            if (s5 !== peg$FAILED) {
// @ts-ignore
              peg$savedPos = s0;
// @ts-ignore
              s0 = peg$f36(s1, s3, s5);
// @ts-ignore
            } else {
// @ts-ignore
              peg$currPos = s0;
// @ts-ignore
              s0 = peg$FAILED;
            }
// @ts-ignore
          } else {
// @ts-ignore
            peg$currPos = s0;
// @ts-ignore
            s0 = peg$FAILED;
          }
// @ts-ignore
        } else {
// @ts-ignore
          peg$currPos = s0;
// @ts-ignore
          s0 = peg$FAILED;
        }
// @ts-ignore
      } else {
// @ts-ignore
        peg$currPos = s0;
// @ts-ignore
        s0 = peg$FAILED;
      }
// @ts-ignore
    } else {
// @ts-ignore
      peg$currPos = s0;
// @ts-ignore
      s0 = peg$FAILED;
    }
// @ts-ignore
    if (s0 === peg$FAILED) {
// @ts-ignore
      s0 = peg$currPos;
// @ts-ignore
      s1 = peg$parseBaseExpression();
// @ts-ignore
      if (s1 !== peg$FAILED) {
// @ts-ignore
        s2 = peg$parse_();
// @ts-ignore
        s3 = peg$parseKeywordAnd();
// @ts-ignore
        if (s3 !== peg$FAILED) {
// @ts-ignore
          s4 = peg$parse_();
// @ts-ignore
          s5 = peg$parseMaybeAndExpression();
// @ts-ignore
          if (s5 !== peg$FAILED) {
// @ts-ignore
            peg$savedPos = s0;
// @ts-ignore
            s0 = peg$f37(s1, s2, s3, s4, s5);
// @ts-ignore
          } else {
// @ts-ignore
            peg$currPos = s0;
// @ts-ignore
            s0 = peg$FAILED;
          }
// @ts-ignore
        } else {
// @ts-ignore
          peg$currPos = s0;
// @ts-ignore
          s0 = peg$FAILED;
        }
// @ts-ignore
      } else {
// @ts-ignore
        peg$currPos = s0;
// @ts-ignore
        s0 = peg$FAILED;
      }
// @ts-ignore
      if (s0 === peg$FAILED) {
// @ts-ignore
        s0 = peg$currPos;
// @ts-ignore
        s1 = peg$parseBaseExpression();
// @ts-ignore
        if (s1 !== peg$FAILED) {
// @ts-ignore
          s2 = peg$parse__();
// @ts-ignore
          if (s2 !== peg$FAILED) {
// @ts-ignore
            s3 = peg$parseKeywordAnd();
// @ts-ignore
            if (s3 !== peg$FAILED) {
// @ts-ignore
              s4 = peg$parse_();
// @ts-ignore
              s5 = peg$currPos;
// @ts-ignore
              peg$silentFails++;
// @ts-ignore
              s6 = peg$parseMaybeAndExpression();
// @ts-ignore
              peg$silentFails--;
// @ts-ignore
              if (s6 === peg$FAILED) {
// @ts-ignore
                s5 = undefined;
// @ts-ignore
              } else {
// @ts-ignore
                peg$currPos = s5;
// @ts-ignore
                s5 = peg$FAILED;
              }
// @ts-ignore
              if (s5 !== peg$FAILED) {
// @ts-ignore
                peg$savedPos = s0;
// @ts-ignore
                s0 = peg$f38(s3);
// @ts-ignore
              } else {
// @ts-ignore
                peg$currPos = s0;
// @ts-ignore
                s0 = peg$FAILED;
              }
// @ts-ignore
            } else {
// @ts-ignore
              peg$currPos = s0;
// @ts-ignore
              s0 = peg$FAILED;
            }
// @ts-ignore
          } else {
// @ts-ignore
            peg$currPos = s0;
// @ts-ignore
            s0 = peg$FAILED;
          }
// @ts-ignore
        } else {
// @ts-ignore
          peg$currPos = s0;
// @ts-ignore
          s0 = peg$FAILED;
        }
      }
    }

// @ts-ignore
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

// @ts-ignore
    return s0;
  }

// @ts-ignore
  function // @ts-ignore
peg$parseImplicitAndExpression() {
// @ts-ignore
    let s0, s1, s2, s3;

// @ts-ignore
    const key = peg$currPos * 41 + 31;
// @ts-ignore
    const cached = peg$resultsCache[key];

// @ts-ignore
    if (cached) {
// @ts-ignore
      peg$currPos = cached.nextPos;

// @ts-ignore
      return cached.result;
    }

// @ts-ignore
    s0 = peg$currPos;
// @ts-ignore
    s1 = peg$parseBaseExpression();
// @ts-ignore
    if (s1 !== peg$FAILED) {
// @ts-ignore
      s2 = peg$parse_();
// @ts-ignore
      s3 = peg$parseMaybeAndExpression();
// @ts-ignore
      if (s3 !== peg$FAILED) {
// @ts-ignore
        peg$savedPos = s0;
// @ts-ignore
        s0 = peg$f39(s1, s3);
// @ts-ignore
      } else {
// @ts-ignore
        peg$currPos = s0;
// @ts-ignore
        s0 = peg$FAILED;
      }
// @ts-ignore
    } else {
// @ts-ignore
      peg$currPos = s0;
// @ts-ignore
      s0 = peg$FAILED;
    }

// @ts-ignore
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

// @ts-ignore
    return s0;
  }

// @ts-ignore
  function // @ts-ignore
peg$parseMaybeOrExpression() {
// @ts-ignore
    let s0;

// @ts-ignore
    const key = peg$currPos * 41 + 32;
// @ts-ignore
    const cached = peg$resultsCache[key];

// @ts-ignore
    if (cached) {
// @ts-ignore
      peg$currPos = cached.nextPos;

// @ts-ignore
      return cached.result;
    }

// @ts-ignore
    s0 = peg$parseOrExpression();
// @ts-ignore
    if (s0 === peg$FAILED) {
// @ts-ignore
      s0 = peg$parseMaybeAndExpression();
    }

// @ts-ignore
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

// @ts-ignore
    return s0;
  }

// @ts-ignore
  function // @ts-ignore
peg$parseOrExpression() {
// @ts-ignore
    let s0, s1, s2, s3, s4, s5, s6;

// @ts-ignore
    const key = peg$currPos * 41 + 33;
// @ts-ignore
    const cached = peg$resultsCache[key];

// @ts-ignore
    if (cached) {
// @ts-ignore
      peg$currPos = cached.nextPos;

// @ts-ignore
      return cached.result;
    }

// @ts-ignore
    s0 = peg$currPos;
// @ts-ignore
    s1 = peg$parseMaybeAndExpression();
// @ts-ignore
    if (s1 !== peg$FAILED) {
// @ts-ignore
      s2 = peg$parse__();
// @ts-ignore
      if (s2 !== peg$FAILED) {
// @ts-ignore
        s3 = peg$parseKeywordOr();
// @ts-ignore
        if (s3 !== peg$FAILED) {
// @ts-ignore
          s4 = peg$parse__();
// @ts-ignore
          if (s4 !== peg$FAILED) {
// @ts-ignore
            s5 = peg$parseMaybeOrExpression();
// @ts-ignore
            if (s5 !== peg$FAILED) {
// @ts-ignore
              peg$savedPos = s0;
// @ts-ignore
              s0 = peg$f40(s1, s3, s5);
// @ts-ignore
            } else {
// @ts-ignore
              peg$currPos = s0;
// @ts-ignore
              s0 = peg$FAILED;
            }
// @ts-ignore
          } else {
// @ts-ignore
            peg$currPos = s0;
// @ts-ignore
            s0 = peg$FAILED;
          }
// @ts-ignore
        } else {
// @ts-ignore
          peg$currPos = s0;
// @ts-ignore
          s0 = peg$FAILED;
        }
// @ts-ignore
      } else {
// @ts-ignore
        peg$currPos = s0;
// @ts-ignore
        s0 = peg$FAILED;
      }
// @ts-ignore
    } else {
// @ts-ignore
      peg$currPos = s0;
// @ts-ignore
      s0 = peg$FAILED;
    }
// @ts-ignore
    if (s0 === peg$FAILED) {
// @ts-ignore
      s0 = peg$currPos;
// @ts-ignore
      s1 = peg$parseMaybeAndExpression();
// @ts-ignore
      if (s1 !== peg$FAILED) {
// @ts-ignore
        s2 = peg$parse_();
// @ts-ignore
        s3 = peg$parseKeywordOr();
// @ts-ignore
        if (s3 !== peg$FAILED) {
// @ts-ignore
          s4 = peg$parse_();
// @ts-ignore
          s5 = peg$parseMaybeOrExpression();
// @ts-ignore
          if (s5 !== peg$FAILED) {
// @ts-ignore
            peg$savedPos = s0;
// @ts-ignore
            s0 = peg$f41(s1, s2, s3, s4, s5);
// @ts-ignore
          } else {
// @ts-ignore
            peg$currPos = s0;
// @ts-ignore
            s0 = peg$FAILED;
          }
// @ts-ignore
        } else {
// @ts-ignore
          peg$currPos = s0;
// @ts-ignore
          s0 = peg$FAILED;
        }
// @ts-ignore
      } else {
// @ts-ignore
        peg$currPos = s0;
// @ts-ignore
        s0 = peg$FAILED;
      }
// @ts-ignore
      if (s0 === peg$FAILED) {
// @ts-ignore
        s0 = peg$currPos;
// @ts-ignore
        s1 = peg$parseMaybeAndExpression();
// @ts-ignore
        if (s1 !== peg$FAILED) {
// @ts-ignore
          s2 = peg$parse__();
// @ts-ignore
          if (s2 !== peg$FAILED) {
// @ts-ignore
            s3 = peg$parseKeywordOr();
// @ts-ignore
            if (s3 !== peg$FAILED) {
// @ts-ignore
              s4 = peg$parse_();
// @ts-ignore
              s5 = peg$currPos;
// @ts-ignore
              peg$silentFails++;
// @ts-ignore
              s6 = peg$parseMaybeOrExpression();
// @ts-ignore
              peg$silentFails--;
// @ts-ignore
              if (s6 === peg$FAILED) {
// @ts-ignore
                s5 = undefined;
// @ts-ignore
              } else {
// @ts-ignore
                peg$currPos = s5;
// @ts-ignore
                s5 = peg$FAILED;
              }
// @ts-ignore
              if (s5 !== peg$FAILED) {
// @ts-ignore
                peg$savedPos = s0;
// @ts-ignore
                s0 = peg$f42(s3);
// @ts-ignore
              } else {
// @ts-ignore
                peg$currPos = s0;
// @ts-ignore
                s0 = peg$FAILED;
              }
// @ts-ignore
            } else {
// @ts-ignore
              peg$currPos = s0;
// @ts-ignore
              s0 = peg$FAILED;
            }
// @ts-ignore
          } else {
// @ts-ignore
            peg$currPos = s0;
// @ts-ignore
            s0 = peg$FAILED;
          }
// @ts-ignore
        } else {
// @ts-ignore
          peg$currPos = s0;
// @ts-ignore
          s0 = peg$FAILED;
        }
      }
    }

// @ts-ignore
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

// @ts-ignore
    return s0;
  }

// @ts-ignore
  function // @ts-ignore
peg$parseNotExpression() {
// @ts-ignore
    let s0, s1, s2, s3;

// @ts-ignore
    const key = peg$currPos * 41 + 34;
// @ts-ignore
    const cached = peg$resultsCache[key];

// @ts-ignore
    if (cached) {
// @ts-ignore
      peg$currPos = cached.nextPos;

// @ts-ignore
      return cached.result;
    }

// @ts-ignore
    s0 = peg$currPos;
// @ts-ignore
    s1 = peg$parseKeywordNot();
// @ts-ignore
    if (s1 !== peg$FAILED) {
// @ts-ignore
      s2 = peg$parse_();
// @ts-ignore
      s3 = peg$parseBaseExpression();
// @ts-ignore
      if (s3 === peg$FAILED) {
// @ts-ignore
        s3 = null;
      }
// @ts-ignore
      peg$savedPos = s0;
// @ts-ignore
      s0 = peg$f43(s1, s2, s3);
// @ts-ignore
    } else {
// @ts-ignore
      peg$currPos = s0;
// @ts-ignore
      s0 = peg$FAILED;
    }

// @ts-ignore
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

// @ts-ignore
    return s0;
  }

// @ts-ignore
  function // @ts-ignore
peg$parseInt() {
// @ts-ignore
    let s0, s1, s2, s3, s4;

// @ts-ignore
    const key = peg$currPos * 41 + 35;
// @ts-ignore
    const cached = peg$resultsCache[key];

// @ts-ignore
    if (cached) {
// @ts-ignore
      peg$currPos = cached.nextPos;

// @ts-ignore
      return cached.result;
    }

// @ts-ignore
    s0 = peg$currPos;
// @ts-ignore
    if (input.charCodeAt(peg$currPos) === 45) {
// @ts-ignore
      s1 = peg$c24;
// @ts-ignore
      peg$currPos++;
// @ts-ignore
    } else {
// @ts-ignore
      s1 = peg$FAILED;
// @ts-ignore
      if (peg$silentFails === 0) { peg$fail(peg$e34); }
    }
// @ts-ignore
    if (s1 === peg$FAILED) {
// @ts-ignore
      s1 = null;
    }
// @ts-ignore
    s2 = [];
// @ts-ignore
    s3 = input.charAt(peg$currPos);
// @ts-ignore
    if (peg$r8.test(s3)) {
// @ts-ignore
      peg$currPos++;
// @ts-ignore
    } else {
// @ts-ignore
      s3 = peg$FAILED;
// @ts-ignore
      if (peg$silentFails === 0) { peg$fail(peg$e35); }
    }
// @ts-ignore
    if (s3 !== peg$FAILED) {
// @ts-ignore
      while (s3 !== peg$FAILED) {
// @ts-ignore
        s2.push(s3);
// @ts-ignore
        s3 = input.charAt(peg$currPos);
// @ts-ignore
        if (peg$r8.test(s3)) {
// @ts-ignore
          peg$currPos++;
// @ts-ignore
        } else {
// @ts-ignore
          s3 = peg$FAILED;
// @ts-ignore
          if (peg$silentFails === 0) { peg$fail(peg$e35); }
        }
      }
// @ts-ignore
    } else {
// @ts-ignore
      s2 = peg$FAILED;
    }
// @ts-ignore
    if (s2 !== peg$FAILED) {
// @ts-ignore
      s3 = peg$currPos;
// @ts-ignore
      peg$silentFails++;
// @ts-ignore
      s4 = input.charAt(peg$currPos);
// @ts-ignore
      if (peg$r1.test(s4)) {
// @ts-ignore
        peg$currPos++;
// @ts-ignore
      } else {
// @ts-ignore
        s4 = peg$FAILED;
// @ts-ignore
        if (peg$silentFails === 0) { peg$fail(peg$e9); }
      }
// @ts-ignore
      peg$silentFails--;
// @ts-ignore
      if (s4 === peg$FAILED) {
// @ts-ignore
        s3 = undefined;
// @ts-ignore
      } else {
// @ts-ignore
        peg$currPos = s3;
// @ts-ignore
        s3 = peg$FAILED;
      }
// @ts-ignore
      if (s3 !== peg$FAILED) {
// @ts-ignore
        peg$savedPos = s0;
// @ts-ignore
        s0 = peg$f44();
// @ts-ignore
      } else {
// @ts-ignore
        peg$currPos = s0;
// @ts-ignore
        s0 = peg$FAILED;
      }
// @ts-ignore
    } else {
// @ts-ignore
      peg$currPos = s0;
// @ts-ignore
      s0 = peg$FAILED;
    }

// @ts-ignore
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

// @ts-ignore
    return s0;
  }

// @ts-ignore
  function // @ts-ignore
peg$parseBool() {
// @ts-ignore
    let s0, s1;

// @ts-ignore
    const key = peg$currPos * 41 + 36;
// @ts-ignore
    const cached = peg$resultsCache[key];

// @ts-ignore
    if (cached) {
// @ts-ignore
      peg$currPos = cached.nextPos;

// @ts-ignore
      return cached.result;
    }

// @ts-ignore
    s0 = peg$currPos;
// @ts-ignore
    s1 = input.substr(peg$currPos, 4);
// @ts-ignore
    if (s1.toLowerCase() === peg$c25) {
// @ts-ignore
      peg$currPos += (4);
// @ts-ignore
    } else {
// @ts-ignore
      s1 = peg$FAILED;
// @ts-ignore
      if (peg$silentFails === 0) { peg$fail(peg$e36); }
    }
// @ts-ignore
    if (s1 !== peg$FAILED) {
// @ts-ignore
      peg$savedPos = s0;
// @ts-ignore
      s1 = peg$f45();
    }
// @ts-ignore
    s0 = s1;
// @ts-ignore
    if (s0 === peg$FAILED) {
// @ts-ignore
      s0 = peg$currPos;
// @ts-ignore
      s1 = input.substr(peg$currPos, 5);
// @ts-ignore
      if (s1.toLowerCase() === peg$c26) {
// @ts-ignore
        peg$currPos += (5);
// @ts-ignore
      } else {
// @ts-ignore
        s1 = peg$FAILED;
// @ts-ignore
        if (peg$silentFails === 0) { peg$fail(peg$e37); }
      }
// @ts-ignore
      if (s1 !== peg$FAILED) {
// @ts-ignore
        peg$savedPos = s0;
// @ts-ignore
        s1 = peg$f46();
      }
// @ts-ignore
      s0 = s1;
    }

// @ts-ignore
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

// @ts-ignore
    return s0;
  }

// @ts-ignore
  function // @ts-ignore
peg$parseFloat() {
// @ts-ignore
    let s0, s1, s2, s3, s4, s5, s6;

// @ts-ignore
    const key = peg$currPos * 41 + 37;
// @ts-ignore
    const cached = peg$resultsCache[key];

// @ts-ignore
    if (cached) {
// @ts-ignore
      peg$currPos = cached.nextPos;

// @ts-ignore
      return cached.result;
    }

// @ts-ignore
    s0 = peg$currPos;
// @ts-ignore
    if (input.charCodeAt(peg$currPos) === 45) {
// @ts-ignore
      s1 = peg$c24;
// @ts-ignore
      peg$currPos++;
// @ts-ignore
    } else {
// @ts-ignore
      s1 = peg$FAILED;
// @ts-ignore
      if (peg$silentFails === 0) { peg$fail(peg$e34); }
    }
// @ts-ignore
    if (s1 === peg$FAILED) {
// @ts-ignore
      s1 = null;
    }
// @ts-ignore
    s2 = [];
// @ts-ignore
    s3 = input.charAt(peg$currPos);
// @ts-ignore
    if (peg$r8.test(s3)) {
// @ts-ignore
      peg$currPos++;
// @ts-ignore
    } else {
// @ts-ignore
      s3 = peg$FAILED;
// @ts-ignore
      if (peg$silentFails === 0) { peg$fail(peg$e35); }
    }
// @ts-ignore
    if (s3 !== peg$FAILED) {
// @ts-ignore
      while (s3 !== peg$FAILED) {
// @ts-ignore
        s2.push(s3);
// @ts-ignore
        s3 = input.charAt(peg$currPos);
// @ts-ignore
        if (peg$r8.test(s3)) {
// @ts-ignore
          peg$currPos++;
// @ts-ignore
        } else {
// @ts-ignore
          s3 = peg$FAILED;
// @ts-ignore
          if (peg$silentFails === 0) { peg$fail(peg$e35); }
        }
      }
// @ts-ignore
    } else {
// @ts-ignore
      s2 = peg$FAILED;
    }
// @ts-ignore
    if (s2 !== peg$FAILED) {
// @ts-ignore
      if (input.charCodeAt(peg$currPos) === 46) {
// @ts-ignore
        s3 = peg$c12;
// @ts-ignore
        peg$currPos++;
// @ts-ignore
      } else {
// @ts-ignore
        s3 = peg$FAILED;
// @ts-ignore
        if (peg$silentFails === 0) { peg$fail(peg$e19); }
      }
// @ts-ignore
      if (s3 !== peg$FAILED) {
// @ts-ignore
        s4 = [];
// @ts-ignore
        s5 = input.charAt(peg$currPos);
// @ts-ignore
        if (peg$r8.test(s5)) {
// @ts-ignore
          peg$currPos++;
// @ts-ignore
        } else {
// @ts-ignore
          s5 = peg$FAILED;
// @ts-ignore
          if (peg$silentFails === 0) { peg$fail(peg$e35); }
        }
// @ts-ignore
        while (s5 !== peg$FAILED) {
// @ts-ignore
          s4.push(s5);
// @ts-ignore
          s5 = input.charAt(peg$currPos);
// @ts-ignore
          if (peg$r8.test(s5)) {
// @ts-ignore
            peg$currPos++;
// @ts-ignore
          } else {
// @ts-ignore
            s5 = peg$FAILED;
// @ts-ignore
            if (peg$silentFails === 0) { peg$fail(peg$e35); }
          }
        }
// @ts-ignore
        s5 = peg$currPos;
// @ts-ignore
        peg$silentFails++;
// @ts-ignore
        s6 = input.charAt(peg$currPos);
// @ts-ignore
        if (peg$r1.test(s6)) {
// @ts-ignore
          peg$currPos++;
// @ts-ignore
        } else {
// @ts-ignore
          s6 = peg$FAILED;
// @ts-ignore
          if (peg$silentFails === 0) { peg$fail(peg$e9); }
        }
// @ts-ignore
        peg$silentFails--;
// @ts-ignore
        if (s6 === peg$FAILED) {
// @ts-ignore
          s5 = undefined;
// @ts-ignore
        } else {
// @ts-ignore
          peg$currPos = s5;
// @ts-ignore
          s5 = peg$FAILED;
        }
// @ts-ignore
        if (s5 !== peg$FAILED) {
// @ts-ignore
          peg$savedPos = s0;
// @ts-ignore
          s0 = peg$f47();
// @ts-ignore
        } else {
// @ts-ignore
          peg$currPos = s0;
// @ts-ignore
          s0 = peg$FAILED;
        }
// @ts-ignore
      } else {
// @ts-ignore
        peg$currPos = s0;
// @ts-ignore
        s0 = peg$FAILED;
      }
// @ts-ignore
    } else {
// @ts-ignore
      peg$currPos = s0;
// @ts-ignore
      s0 = peg$FAILED;
    }
// @ts-ignore
    if (s0 === peg$FAILED) {
// @ts-ignore
      s0 = peg$currPos;
// @ts-ignore
      if (input.charCodeAt(peg$currPos) === 45) {
// @ts-ignore
        s1 = peg$c24;
// @ts-ignore
        peg$currPos++;
// @ts-ignore
      } else {
// @ts-ignore
        s1 = peg$FAILED;
// @ts-ignore
        if (peg$silentFails === 0) { peg$fail(peg$e34); }
      }
// @ts-ignore
      if (s1 === peg$FAILED) {
// @ts-ignore
        s1 = null;
      }
// @ts-ignore
      s2 = [];
// @ts-ignore
      s3 = input.charAt(peg$currPos);
// @ts-ignore
      if (peg$r8.test(s3)) {
// @ts-ignore
        peg$currPos++;
// @ts-ignore
      } else {
// @ts-ignore
        s3 = peg$FAILED;
// @ts-ignore
        if (peg$silentFails === 0) { peg$fail(peg$e35); }
      }
// @ts-ignore
      while (s3 !== peg$FAILED) {
// @ts-ignore
        s2.push(s3);
// @ts-ignore
        s3 = input.charAt(peg$currPos);
// @ts-ignore
        if (peg$r8.test(s3)) {
// @ts-ignore
          peg$currPos++;
// @ts-ignore
        } else {
// @ts-ignore
          s3 = peg$FAILED;
// @ts-ignore
          if (peg$silentFails === 0) { peg$fail(peg$e35); }
        }
      }
// @ts-ignore
      if (input.charCodeAt(peg$currPos) === 46) {
// @ts-ignore
        s3 = peg$c12;
// @ts-ignore
        peg$currPos++;
// @ts-ignore
      } else {
// @ts-ignore
        s3 = peg$FAILED;
// @ts-ignore
        if (peg$silentFails === 0) { peg$fail(peg$e19); }
      }
// @ts-ignore
      if (s3 !== peg$FAILED) {
// @ts-ignore
        s4 = [];
// @ts-ignore
        s5 = input.charAt(peg$currPos);
// @ts-ignore
        if (peg$r8.test(s5)) {
// @ts-ignore
          peg$currPos++;
// @ts-ignore
        } else {
// @ts-ignore
          s5 = peg$FAILED;
// @ts-ignore
          if (peg$silentFails === 0) { peg$fail(peg$e35); }
        }
// @ts-ignore
        if (s5 !== peg$FAILED) {
// @ts-ignore
          while (s5 !== peg$FAILED) {
// @ts-ignore
            s4.push(s5);
// @ts-ignore
            s5 = input.charAt(peg$currPos);
// @ts-ignore
            if (peg$r8.test(s5)) {
// @ts-ignore
              peg$currPos++;
// @ts-ignore
            } else {
// @ts-ignore
              s5 = peg$FAILED;
// @ts-ignore
              if (peg$silentFails === 0) { peg$fail(peg$e35); }
            }
          }
// @ts-ignore
        } else {
// @ts-ignore
          s4 = peg$FAILED;
        }
// @ts-ignore
        if (s4 !== peg$FAILED) {
// @ts-ignore
          s5 = peg$currPos;
// @ts-ignore
          peg$silentFails++;
// @ts-ignore
          s6 = input.charAt(peg$currPos);
// @ts-ignore
          if (peg$r1.test(s6)) {
// @ts-ignore
            peg$currPos++;
// @ts-ignore
          } else {
// @ts-ignore
            s6 = peg$FAILED;
// @ts-ignore
            if (peg$silentFails === 0) { peg$fail(peg$e9); }
          }
// @ts-ignore
          peg$silentFails--;
// @ts-ignore
          if (s6 === peg$FAILED) {
// @ts-ignore
            s5 = undefined;
// @ts-ignore
          } else {
// @ts-ignore
            peg$currPos = s5;
// @ts-ignore
            s5 = peg$FAILED;
          }
// @ts-ignore
          if (s5 !== peg$FAILED) {
// @ts-ignore
            peg$savedPos = s0;
// @ts-ignore
            s0 = peg$f48();
// @ts-ignore
          } else {
// @ts-ignore
            peg$currPos = s0;
// @ts-ignore
            s0 = peg$FAILED;
          }
// @ts-ignore
        } else {
// @ts-ignore
          peg$currPos = s0;
// @ts-ignore
          s0 = peg$FAILED;
        }
// @ts-ignore
      } else {
// @ts-ignore
        peg$currPos = s0;
// @ts-ignore
        s0 = peg$FAILED;
      }
    }

// @ts-ignore
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

// @ts-ignore
    return s0;
  }

// @ts-ignore
  function // @ts-ignore
peg$parse_() {
// @ts-ignore
    let s0, s1;

// @ts-ignore
    const key = peg$currPos * 41 + 38;
// @ts-ignore
    const cached = peg$resultsCache[key];

// @ts-ignore
    if (cached) {
// @ts-ignore
      peg$currPos = cached.nextPos;

// @ts-ignore
      return cached.result;
    }

// @ts-ignore
    peg$silentFails++;
// @ts-ignore
    s0 = [];
// @ts-ignore
    s1 = input.charAt(peg$currPos);
// @ts-ignore
    if (peg$r9.test(s1)) {
// @ts-ignore
      peg$currPos++;
// @ts-ignore
    } else {
// @ts-ignore
      s1 = peg$FAILED;
// @ts-ignore
      if (peg$silentFails === 0) { peg$fail(peg$e38); }
    }
// @ts-ignore
    while (s1 !== peg$FAILED) {
// @ts-ignore
      s0.push(s1);
// @ts-ignore
      s1 = input.charAt(peg$currPos);
// @ts-ignore
      if (peg$r9.test(s1)) {
// @ts-ignore
        peg$currPos++;
// @ts-ignore
      } else {
// @ts-ignore
        s1 = peg$FAILED;
// @ts-ignore
        if (peg$silentFails === 0) { peg$fail(peg$e38); }
      }
    }
// @ts-ignore
    peg$silentFails--;

// @ts-ignore
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

// @ts-ignore
    return s0;
  }

// @ts-ignore
  function // @ts-ignore
peg$parse__() {
// @ts-ignore
    let s0, s1;

// @ts-ignore
    const key = peg$currPos * 41 + 39;
// @ts-ignore
    const cached = peg$resultsCache[key];

// @ts-ignore
    if (cached) {
// @ts-ignore
      peg$currPos = cached.nextPos;

// @ts-ignore
      return cached.result;
    }

// @ts-ignore
    peg$silentFails++;
// @ts-ignore
    s0 = [];
// @ts-ignore
    s1 = input.charAt(peg$currPos);
// @ts-ignore
    if (peg$r9.test(s1)) {
// @ts-ignore
      peg$currPos++;
// @ts-ignore
    } else {
// @ts-ignore
      s1 = peg$FAILED;
// @ts-ignore
      if (peg$silentFails === 0) { peg$fail(peg$e38); }
    }
// @ts-ignore
    if (s1 !== peg$FAILED) {
// @ts-ignore
      while (s1 !== peg$FAILED) {
// @ts-ignore
        s0.push(s1);
// @ts-ignore
        s1 = input.charAt(peg$currPos);
// @ts-ignore
        if (peg$r9.test(s1)) {
// @ts-ignore
          peg$currPos++;
// @ts-ignore
        } else {
// @ts-ignore
          s1 = peg$FAILED;
// @ts-ignore
          if (peg$silentFails === 0) { peg$fail(peg$e38); }
        }
      }
// @ts-ignore
    } else {
// @ts-ignore
      s0 = peg$FAILED;
    }
// @ts-ignore
    peg$silentFails--;
// @ts-ignore
    if (s0 === peg$FAILED) {
// @ts-ignore
      s1 = peg$FAILED;
// @ts-ignore
      if (peg$silentFails === 0) { peg$fail(peg$e39); }
    }

// @ts-ignore
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

// @ts-ignore
    return s0;
  }

// @ts-ignore
  function // @ts-ignore
peg$parseEOF() {
// @ts-ignore
    let s0, s1;

// @ts-ignore
    const key = peg$currPos * 41 + 40;
// @ts-ignore
    const cached = peg$resultsCache[key];

// @ts-ignore
    if (cached) {
// @ts-ignore
      peg$currPos = cached.nextPos;

// @ts-ignore
      return cached.result;
    }

// @ts-ignore
    s0 = peg$currPos;
// @ts-ignore
    peg$silentFails++;
// @ts-ignore
    if (input.length > peg$currPos) {
// @ts-ignore
      s1 = input.charAt(peg$currPos);
// @ts-ignore
      peg$currPos++;
// @ts-ignore
    } else {
// @ts-ignore
      s1 = peg$FAILED;
// @ts-ignore
      if (peg$silentFails === 0) { peg$fail(peg$e40); }
    }
// @ts-ignore
    peg$silentFails--;
// @ts-ignore
    if (s1 === peg$FAILED) {
// @ts-ignore
      s0 = undefined;
// @ts-ignore
    } else {
// @ts-ignore
      peg$currPos = s0;
// @ts-ignore
      s0 = peg$FAILED;
    }

// @ts-ignore
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };

// @ts-ignore
    return s0;
  }

// @ts-ignore
  peg$result = peg$startRuleFunction();

// @ts-ignore
  const peg$success = (peg$result !== peg$FAILED && peg$currPos === input.length);
// @ts-ignore
  function peg$throw() {
// @ts-ignore
    if (peg$result !== peg$FAILED && peg$currPos < input.length) {
// @ts-ignore
      peg$fail(peg$endExpectation());
    }

// @ts-ignore
    throw peg$buildStructuredError(
// @ts-ignore
      peg$maxFailExpected,
// @ts-ignore
      peg$maxFailPos < input.length ? peg$getUnicode(peg$maxFailPos) : null,
// @ts-ignore
      peg$maxFailPos < input.length
// @ts-ignore
        ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1)
// @ts-ignore
        : peg$computeLocation(peg$maxFailPos, peg$maxFailPos)
    );
  }
// @ts-ignore
  if (options.peg$library) {
// @ts-ignore
    return /** @type {any} */ ({
// @ts-ignore
      peg$result,
// @ts-ignore
      peg$currPos,
// @ts-ignore
      peg$FAILED,
// @ts-ignore
      peg$maxFailExpected,
// @ts-ignore
      peg$maxFailPos,
// @ts-ignore
      peg$success,
// @ts-ignore
      peg$throw: peg$success ? undefined : peg$throw,
    });
  }
// @ts-ignore
  if (peg$success) {
// @ts-ignore
    return peg$result;
// @ts-ignore
  } else {
// @ts-ignore
    peg$throw();
  }
}
// @ts-ignore
  return {
    StartRules: ["Filter"],
    SyntaxError: peg$SyntaxError,
    parse: peg$parse,
  };
})()

export interface FilePosition {
  offset: number;
  line: number;
  column: number;
}

export interface FileRange {
  start: FilePosition;
  end: FilePosition;
  source: string;
}

export interface LiteralExpectation {
  type: "literal";
  text: string;
  ignoreCase: boolean;
}

export interface ClassParts extends Array<string | ClassParts> {}

export interface ClassExpectation {
  type: "class";
  parts: ClassParts;
  inverted: boolean;
  ignoreCase: boolean;
}

export interface AnyExpectation {
  type: "any";
}

export interface EndExpectation {
  type: "end";
}

export interface OtherExpectation {
  type: "other";
  description: string;
}

export type Expectation = LiteralExpectation | ClassExpectation | AnyExpectation | EndExpectation | OtherExpectation;

declare class _PeggySyntaxError extends Error {
  public static buildMessage(expected: Expectation[], found: string | null): string;
  public message: string;
  public expected: Expectation[];
  public found: string | null;
  public location: FileRange;
  public name: string;
  constructor(message: string, expected: Expectation[], found: string | null, location: FileRange);
  format(sources: {
    source?: any;
    text: string;
  }[]): string;
}

export interface TraceEvent {
    type: string;
    rule: string;
    result?: any;
    location: FileRange;
  }

declare class _DefaultTracer {
  private indentLevel: number;
  public trace(event: TraceEvent): void;
}

peggyParser.SyntaxError.prototype.name = "PeggySyntaxError";

export interface ParseOptions {
  filename?: string;
  startRule?: "Filter";
  tracer?: any;
  [key: string]: any;
}
export type ParseFunction = <Options extends ParseOptions>(
    input: string,
    options?: Options
  ) => Options extends { startRule: infer StartRule } ?
    StartRule extends "Filter" ? Filter : Filter
    : Filter;
export const parse: ParseFunction = peggyParser.parse;

export const PeggySyntaxError = peggyParser.SyntaxError as typeof _PeggySyntaxError;

export type PeggySyntaxError = _PeggySyntaxError;

// These types were autogenerated by ts-pegjs
export type Filter = Expression | null;
export type Keyword = [string, undefined];
export type KeywordNot = {
  value: string;
  location: {
    source: string | undefined;
    start: { offset: number; line: number; column: number };
    end: { offset: number; line: number; column: number };
  };
};
export type KeywordIn = {
  value: string;
  location: {
    source: string | undefined;
    start: { offset: number; line: number; column: number };
    end: { offset: number; line: number; column: number };
  };
};
export type KeywordIs = {
  value: string;
  location: {
    source: string | undefined;
    start: { offset: number; line: number; column: number };
    end: { offset: number; line: number; column: number };
  };
};
export type KeywordNull = {
  value: string;
  location: {
    source: string | undefined;
    start: { offset: number; line: number; column: number };
    end: { offset: number; line: number; column: number };
  };
};
export type KeywordContains = {
  value: string;
  location: {
    source: string | undefined;
    start: { offset: number; line: number; column: number };
    end: { offset: number; line: number; column: number };
  };
};
export type KeywordEmpty = {
  value: string;
  location: {
    source: string | undefined;
    start: { offset: number; line: number; column: number };
    end: { offset: number; line: number; column: number };
  };
};
export type KeywordAnd = {
  value: string;
  location: {
    source: string | undefined;
    start: { offset: number; line: number; column: number };
    end: { offset: number; line: number; column: number };
  };
};
export type KeywordOr = {
  value: string;
  location: {
    source: string | undefined;
    start: { offset: number; line: number; column: number };
    end: { offset: number; line: number; column: number };
  };
};
export type RawString = {
  kind: "raw-string";
  value: string;
  location: {
    source: string | undefined;
    start: { offset: number; line: number; column: number };
    end: { offset: number; line: number; column: number };
  };
  text: string;
};
export type QuotedString =
  | {
      kind: "quoted-string";
      value: string;
      location: {
        source: string | undefined;
        start: { offset: number; line: number; column: number };
        end: { offset: number; line: number; column: number };
      };
      text: string;
      complete: true;
    }
  | {
      kind: "quoted-string";
      value: string;
      location: {
        source: string | undefined;
        start: { offset: number; line: number; column: number };
        end: { offset: number; line: number; column: number };
      };
      text: string;
      complete: false;
    };
export type QuotedKeyValue = {
  kind: "quoted-key-value";
  key: QuotedString;
  keyLocation: any;
  value: QuotedString;
  valueLocation: any;
  position: {
    source: string | undefined;
    start: { offset: number; line: number; column: number };
    end: { offset: number; line: number; column: number };
  };
  text: string;
  complete: boolean;
};
export type Value =
  | QuotedKeyValue
  | Float
  | Int
  | Bool
  | RawString
  | QuotedString;
export type ValuesList = (Value | ValuesList[number])[] | [Value];
export type Identifier =
  | {
      kind: "identifier";
      type: "Identifier";
      location: {
        source: string | undefined;
        start: { offset: number; line: number; column: number };
        end: { offset: number; line: number; column: number };
      };
      segments: IdentifierSegment[];
      value: string;
      text: string;
    }
  | {
      kind: "identifier";
      value: any;
      text: any;
      type: "Identifier";
      location: {
        source: string | undefined;
        start: { offset: number; line: number; column: number };
        end: { offset: number; line: number; column: number };
      };
      segments: [IdentifierSegment];
    };
export type IdentifierSegment = {
  type: "IdentifierSegment";
  position: {
    source: string | undefined;
    start: { offset: number; line: number; column: number };
    end: { offset: number; line: number; column: number };
  };
  name: string;
};
export type QuotedIdentifierSegmentBody = string;
export type Expression = MaybeOrExpression | void;
export type ParenthesizedExpression = {
  kind: "parenthesized-expression";
  expr: Expression;
  position: {
    source: string | undefined;
    start: { offset: number; line: number; column: number };
    end: { offset: number; line: number; column: number };
  };
  text: string;
  complete: boolean;
};
export type SearchExpression = {
  kind: "search-expression";
  query: RawString | QuotedString | Float | Int | Bool;
  position: {
    source: string | undefined;
    start: { offset: number; line: number; column: number };
    end: { offset: number; line: number; column: number };
  };
  text: string;
  complete: true;
};
export type ComparisonExpression = {
  kind: "comparison-expression";
  identifier: Identifier;
  identifierLocation: any;
  op: any;
  opLocation: any;
  value: ((Value | null) & {}) | undefined;
  valueLocation: any;
  position: {
    source: string | undefined;
    start: { offset: number; line: number; column: number };
    end: { offset: number; line: number; column: number };
  };
  text: string;
  complete: boolean;
  context: "value";
};
export type ComparisonOperator = {
  value: string;
  location: {
    source: string | undefined;
    start: { offset: number; line: number; column: number };
    end: { offset: number; line: number; column: number };
  };
};
export type PossibleComparisonExpression = {
  kind: "incomplete-expression";
  identifier: Identifier;
  identifierLocation: any;
  op: string;
  opLocation: {
    start: { offset: any; line: number; column: any };
    end: { offset: number; line: number; column: number };
  };
  value: null;
  position: {
    source: string | undefined;
    start: { offset: number; line: number; column: number };
    end: { offset: number; line: number; column: number };
  };
  text: string;
  complete: false;
  context: "value" | "operator" | "field";
};
export type IsExpression =
  | {
      kind: "void-expression";
      identifier: Identifier;
      identifierLocation: any;
      op: string;
      opLocation: { is: any; empty: any };
      position: {
        source: string | undefined;
        start: { offset: number; line: number; column: number };
        end: { offset: number; line: number; column: number };
      };
      text: string;
      complete: true;
    }
  | {
      kind: "void-expression";
      identifier: Identifier;
      identifierLocation: any;
      op: string;
      opLocation: { is: any; null: any };
      position: {
        source: string | undefined;
        start: { offset: number; line: number; column: number };
        end: { offset: number; line: number; column: number };
      };
      text: string;
      complete: true;
    }
  | {
      kind: "void-expression";
      identifier: Identifier;
      identifierLocation: any;
      op: string;
      opLocation: { is: any; not: any; null: any };
      position: {
        source: string | undefined;
        start: { offset: number; line: number; column: number };
        end: { offset: number; line: number; column: number };
      };
      text: string;
      complete: true;
    }
  | {
      kind: "void-expression";
      identifier: Identifier;
      identifierLocation: any;
      op: string;
      opLocation: { is: any; not: any; empty: any };
      position: {
        source: string | undefined;
        start: { offset: number; line: number; column: number };
        end: { offset: number; line: number; column: number };
      };
      text: string;
      complete: true;
    };
export type InExpression = {
  kind: "list-expression";
  identifier: Identifier;
  identifierLocation: any;
  values: ((ValuesList | null) & {}) | undefined;
  valuesLocation: { start: number; end: number } | undefined;
  position: {
    source: string | undefined;
    start: { offset: number; line: number; column: number };
    end: { offset: number; line: number; column: number };
  };
  op: any;
  opLocation: any;
  text: string;
  complete: boolean;
  context: "value";
};
export type NotInExpression = {
  kind: "list-expression";
  identifier: Identifier;
  identifierLocation: any;
  values: ((ValuesList | null) & {}) | undefined;
  valuesLocation: { start: number; end: number } | undefined;
  position: {
    source: string | undefined;
    start: { offset: number; line: number; column: number };
    end: { offset: number; line: number; column: number };
  };
  op: string;
  opLocation: { not: any; in: any };
  text: string;
  complete: boolean;
};
export type ContainsExpression = {
  kind: "contains-expression";
  identifier: Identifier;
  identifierLocation: any;
  op: any;
  opLocation: any;
  value: ((Value | null) & {}) | undefined;
  valueLocation: any;
  position: {
    source: string | undefined;
    start: { offset: number; line: number; column: number };
    end: { offset: number; line: number; column: number };
  };
  text: string;
  complete: any;
  context: "value";
};
export type BaseExpression =
  | ParenthesizedExpression
  | InExpression
  | NotInExpression
  | NotExpression
  | ComparisonExpression
  | IsExpression
  | ContainsExpression
  | QuotedKeyValue
  | PossibleComparisonExpression
  | SearchExpression;
export type MaybeAndExpression =
  | AndExpression
  | ImplicitAndExpression
  | BaseExpression;
export type AndExpression = {
  kind: "and-expression";
  left: BaseExpression;
  right: MaybeAndExpression;
  op: any;
  opLocation: any;
  position: {
    source: string | undefined;
    start: { offset: number; line: number; column: number };
    end: { offset: number; line: number; column: number };
  };
  text: string;
  complete: boolean;
} | void;
export type ImplicitAndExpression = {
  kind: "implicit-and-expression";
  left: BaseExpression;
  right: MaybeAndExpression;
  position: {
    source: string | undefined;
    start: { offset: number; line: number; column: number };
    end: { offset: number; line: number; column: number };
  };
  text: string;
  complete: boolean;
};
export type MaybeOrExpression = OrExpression | MaybeAndExpression;
export type OrExpression = {
  kind: "or-expression";
  left: MaybeAndExpression;
  right: MaybeOrExpression;
  op: any;
  opLocation: any;
  position: {
    source: string | undefined;
    start: { offset: number; line: number; column: number };
    end: { offset: number; line: number; column: number };
  };
  text: string;
  complete: boolean;
} | void;
export type NotExpression = {
  kind: "not-expression";
  expression: BaseExpression | null;
  op: any;
  opLocation: any;
  position: {
    source: string | undefined;
    start: { offset: number; line: number; column: number };
    end: { offset: number; line: number; column: number };
  };
  text: string;
  complete: boolean;
  context: any;
};
export type Int = {
  kind: "int";
  value: number;
  location: {
    source: string | undefined;
    start: { offset: number; line: number; column: number };
    end: { offset: number; line: number; column: number };
  };
  text: string;
};
export type Bool =
  | {
      kind: "bool";
      value: true;
      location: {
        source: string | undefined;
        start: { offset: number; line: number; column: number };
        end: { offset: number; line: number; column: number };
      };
      text: string;
    }
  | {
      kind: "bool";
      value: false;
      location: {
        source: string | undefined;
        start: { offset: number; line: number; column: number };
        end: { offset: number; line: number; column: number };
      };
      text: string;
    };
export type Float = {
  kind: "float";
  value: number;
  location: {
    source: string | undefined;
    start: { offset: number; line: number; column: number };
    end: { offset: number; line: number; column: number };
  };
  text: string;
};
export type _ = string[];
export type __ = string[];
export type EOF = undefined;
